import React, { useState, useEffect } from "react";

// ══════════════════════════════════════════════════════════════
// NAILSHINE STAFF PORTAL v3.6
// Changes from v3.5:
//   - GIFT CARD payment button (blue), full taxed total
//   - Per-person calendar_event_id + appointment linker on split bills
//   - Walk-in captures the event_id returned by the booking call
//   - Wax store cut baked into the items themselves (was display-only)
//   - Closed tickets lock and collapse — no accidental double-charge
//   - Restored splits take their name from their own draft row
//   - Postgres sync failures are visible instead of silent
//   - My Sales shows who shared a ticket, not what they earned
//   - June system prompt now lives on the server
// ══════════════════════════════════════════════════════════════

const TC = {
  Eunice:  { bg:"#7986CB", tx:"#fff" },
  Coco:    { bg:"#33B679", tx:"#fff" },
  Nikki:   { bg:"#0B8043", tx:"#fff" },
  Rebecca: { bg:"#D50000", tx:"#fff" },
  Sonia:   { bg:"#E67C73", tx:"#fff" },
  Yan:     { bg:"#616161", tx:"#fff" },
  Monica:  { bg:"#3F51B5", tx:"#fff" },
  Cici:    { bg:"#8E24AA", tx:"#fff" },
  Yvette:  { bg:"#795548", tx:"#fff" },
  Zoe:     { bg:"#BDBDBD", tx:"#333" },
  Staff:   { bg:"#444444", tx:"#fff" }
};

const COLOR_ID_TO_TECH = {
  "1":"Eunice","2":"Coco","3":"Cici","4":"Sonia","5":null,"6":null,
  "7":"CANCELLED","8":"Yan","9":"Monica","10":"Nikki","11":"Rebecca",
};
const COLOR_ID_HEX = {
  "1":"#7986CB","2":"#33B679","3":"#8E24AA","4":"#E67C73",
  "5":"#F6BF26","6":"#F4511E","7":"#039BE5","8":"#616161",
  "9":"#3F51B5","10":"#0B8043","11":"#D50000",
};

const SVC = {
  "Bio Gel Refill":        {p:53, sc:6,  tp:47, cat:"hands"},
  "Bio Gel Extensions":    {p:74, sc:7,  tp:67, cat:"hands"},
  "Bio Gel Overlay":       {p:60, sc:7,  tp:53, cat:"hands"},
  "Shellac Manicure":      {p:36, sc:3,  tp:33, cat:"hands"},
  "Classic Manicure":      {p:23, sc:2,  tp:21, cat:"hands"},
  "Shellac Hand Polish":   {p:28, sc:2,  tp:26, cat:"hands"},
  "Regular Polish":        {p:18, sc:0,  tp:18, cat:"hands"},
  "UV Gel Extensions":     {p:68, sc:5,  tp:63, cat:"hands"},
  "UV Gel Overlay":        {p:55, sc:5,  tp:50, cat:"hands"},
  "UV Gel Refill":         {p:47, sc:5,  tp:42, cat:"hands"},
  "Gel Removal":           {p:20, sc:0,  tp:20, cat:"hands"},
  "Shellac Removal Only":  {p:10, sc:0,  tp:10, cat:"hands"},
  "Shellac Removal w/Svc": {p:4,  sc:0,  tp:4,  cat:"hands"},
  "Bros Manicure":         {p:20, sc:0,  tp:20, cat:"hands"},
  "Shellac Pedicure":          {p:50, sc:3, tp:47, cat:"feet"},
  "Classic Pedicure":          {p:36, sc:3, tp:33, cat:"feet"},
  "Deluxe Pedicure":           {p:60, sc:5, tp:55, cat:"feet"},
  "Jelly Pedicure":            {p:55, sc:5, tp:50, cat:"feet"},
  "Shellac Toe Polish":        {p:32, sc:2, tp:30, cat:"feet"},
  "Regular Toe Polish":        {p:18, sc:0, tp:18, cat:"feet"},
  "Bros Pedicure":             {p:36, sc:3, tp:33, cat:"feet"},
  "Shellac Toe Removal Only":  {p:10, sc:0, tp:10, cat:"feet"},
  "Shellac Toe Removal w/Svc": {p:4,  sc:0, tp:4,  cat:"feet"},
  "Classic Mani & Classic Pedi":       {p:54,  sc:2, handTp:20, feetTp:32, cat:"combo", handPart:"Classic Manicure",   feetPart:"Classic Pedicure"},
  "Shellac Mani & Classic Pedi":       {p:68,  sc:3, handTp:33, feetTp:32, cat:"combo", handPart:"Shellac Manicure",   feetPart:"Classic Pedicure"},
  "Shellac Mani & Shellac Pedi":       {p:82,  sc:3, handTp:32, feetTp:47, cat:"combo", handPart:"Shellac Manicure",   feetPart:"Shellac Pedicure"},
  "Bio Gel Refill & Classic Pedi":     {p:82,  sc:3, handTp:47, feetTp:32, cat:"combo", handPart:"Bio Gel Refill",     feetPart:"Classic Pedicure"},
  "Bio Gel Refill & Shellac Pedi":     {p:98,  sc:3, handTp:47, feetTp:48, cat:"combo", handPart:"Bio Gel Refill",     feetPart:"Shellac Pedicure"},
  "Bio Gel Extensions & Classic Pedi": {p:102, sc:3, handTp:67, feetTp:32, cat:"combo", handPart:"Bio Gel Extensions", feetPart:"Classic Pedicure"},
  "Bio Gel Extensions & Shellac Pedi": {p:118, sc:3, handTp:67, feetTp:48, cat:"combo", handPart:"Bio Gel Extensions", feetPart:"Shellac Pedicure"},
  "Bio Gel Overlay & Classic Pedi":    {p:88,  sc:3, handTp:53, feetTp:32, cat:"combo", handPart:"Bio Gel Overlay",    feetPart:"Classic Pedicure"},
  "Bio Gel Overlay & Shellac Pedi":    {p:104, sc:3, handTp:53, feetTp:48, cat:"combo", handPart:"Bio Gel Overlay",    feetPart:"Shellac Pedicure"},
  "Bros & Toes Combo":                 {p:50,  sc:2, handTp:18, feetTp:30, cat:"combo", handPart:"Bros Manicure",      feetPart:"Bros Pedicure"},
  "Waxing - Eyebrow":    {p:12, sc:"wax", tp:12, cat:"wax"},
  "Waxing - Upper Lip":  {p:8,  sc:"wax", tp:8,  cat:"wax"},
  "Waxing - Chin":       {p:8,  sc:"wax", tp:8,  cat:"wax"},
  "Waxing - Cheeks":     {p:8,  sc:"wax", tp:8,  cat:"wax"},
  "Waxing - Sideburns":  {p:8,  sc:"wax", tp:8,  cat:"wax"},
  "Waxing - Full Face":  {p:30, sc:"wax", tp:30, cat:"wax"},
  "Waxing - Underarms":  {p:14, sc:"wax", tp:14, cat:"wax"},
  "Waxing - Half Arms":  {p:22, sc:"wax", tp:22, cat:"wax"},
  "Waxing - Full Arms":  {p:30, sc:"wax", tp:30, cat:"wax"},
  "Waxing - Half Legs":  {p:30, sc:"wax", tp:30, cat:"wax"},
  "Waxing - Full Legs":  {p:45, sc:"wax", tp:45, cat:"wax"},
  "Waxing - Bikini":     {p:20, sc:"wax", tp:20, cat:"wax"},
  "Waxing - Brazilian":  {p:40, sc:"wax", tp:40, cat:"wax"},
  "Waxing - Back":       {p:40, sc:"wax", tp:40, cat:"wax"},
  "Waxing - Chest":      {p:25, sc:"wax", tp:25, cat:"wax"},
  "Waxing - Neck":       {p:12, sc:"wax", tp:12, cat:"wax"},
  "Waxing - Toes/Hands": {p:8,  sc:"wax", tp:8,  cat:"wax"},
  "Classic Eyelash Extensions":   {p:99,  sc:3, tp:96,  cat:"lash"},
  "3D Volume Eyelash Extensions": {p:135, sc:3, tp:132, cat:"lash"},
  "Kids Manicure":    {p:15, sc:0, tp:15, cat:"kids"},
  "Kids Pedicure":    {p:30, sc:0, tp:30, cat:"kids"},
  "Kids Mani & Pedi": {p:42, sc:0, tp:42, cat:"kids"},
  "Kids Hand Polish": {p:12, sc:0, tp:12, cat:"kids"},
  "Kids Feet Polish": {p:12, sc:0, tp:12, cat:"kids"},
};

const CATS = {hands:"💅 Hands",feet:"🦶 Feet",combo:"✨ Combos",wax:"🧖 Wax",lash:"👁️ Lashes",kids:"👧 Kids",addon:"➕ Add-ons"};
const ADDONS = [
  {n:"Design",prs:[5,10,15,20,25,30]},{n:"French Design",prs:[10,15,20]},
  {n:"Chrome",prs:[15]},{n:"Cateye",prs:[15]},{n:"Nail Repair",prs:[4,8,12,15]},
  {n:"Shellac Removal w/Svc",prs:[4]},
];
const CLEAN_TASKS = ["Washroom","Waxing Room","Towels","Pedicure Stations","Manicure Stations","Front Entrance","Back Room"];

// Wax store cut: $3 per tech once that tech's wax on the ticket reaches $30.
const WAX_SC_THRESHOLD = 30;
const WAX_SC_AMOUNT    = 3;

/**
 * Bake the wax store cut into the items themselves.
 *
 * The old code derived wax SC at display time only — the items still went to
 * the server with sc:0 and the full price as tech pay, so the sheet and
 * Postgres recorded the tech as earning the store's $3. Totals still balanced
 * because the row sums, which is why nobody noticed.
 *
 * Recomputed from scratch every time, so it stays correct when wax is added
 * across several trips through the picker or an item is removed.
 */
const applyWaxSc = (rawItems) => {
  const out = rawItems.map(i => ({...i}));
  const byTech = {};
  out.forEach((it, idx) => {
    if (SVC[it.name]?.cat === "wax" && it.tech) {
      if (!byTech[it.tech]) byTech[it.tech] = [];
      byTech[it.tech].push(idx);
    }
  });
  Object.values(byTech).forEach(idxs => {
    idxs.forEach(i => { out[i].sc = 0; out[i].tp = out[i].price; });
    const total = idxs.reduce((a, i) => a + out[i].price, 0);
    if (total >= WAX_SC_THRESHOLD) {
      const first = idxs[0];
      out[first].sc = WAX_SC_AMOUNT;
      out[first].tp = Math.max(0, out[first].price - WAX_SC_AMOUNT);
    }
  });
  return out;
};

const useWidth = () => {
  const[w,s]=useState(window.innerWidth);
  useEffect(()=>{
    const h=()=>s(window.innerWidth);
    window.addEventListener("resize",h);
    return()=>window.removeEventListener("resize",h);
  },[]);
  return w;
};

const Dot=({name,sz=26})=>{
  const c=TC[name]||{bg:"#666",tx:"#fff"};
  return(
    <div style={{width:sz,height:sz,borderRadius:"50%",background:c.bg,display:"flex",alignItems:"center",
      justifyContent:"center",fontSize:sz*.38,fontWeight:700,color:c.tx,flexShrink:0}}>
      {name?.[0]||"?"}
    </div>
  );
};

// Roster dots overflowed the mobile header once more than ~5 techs worked.
const RosterDots=({roster,max=5,sz=26})=>{
  const shown=roster.slice(0,max);
  const extra=roster.length-shown.length;
  return(
    <div style={{display:"flex",gap:4,alignItems:"center"}}>
      {shown.map(t=><Dot key={t} name={t} sz={sz}/>)}
      {extra>0&&(
        <div style={{height:sz,minWidth:sz,padding:"0 6px",borderRadius:sz/2,
          background:"rgba(255,255,255,0.12)",display:"flex",alignItems:"center",
          justifyContent:"center",fontSize:sz*.36,fontWeight:700,color:"#fff"}}>
          +{extra}
        </div>
      )}
    </div>
  );
};

const Modal=({title,onClose,desk,children,footer})=>(
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:100,display:"flex",
    alignItems:desk?"center":"flex-end",justifyContent:"center"}} onClick={onClose}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#111",borderRadius:desk?16:"16px 16px 0 0",
      width:desk?680:"100%",maxHeight:desk?"90vh":"93vh",display:"flex",flexDirection:"column",
      border:"1px solid rgba(255,255,255,0.12)"}}>
      <div style={{padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",
        borderBottom:"1px solid rgba(255,255,255,0.1)",flexShrink:0}}>
        <h3 style={{margin:0,fontSize:17,fontWeight:700,color:"#fff"}}>{title}</h3>
        <button onClick={onClose} style={{background:"rgba(255,255,255,0.1)",border:"none",borderRadius:8,
          color:"#fff",width:34,height:34,fontSize:20,cursor:"pointer",display:"flex",alignItems:"center",
          justifyContent:"center"}}>×</button>
      </div>
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>{children}</div>
      {footer&&<div style={{padding:"12px 16px",borderTop:"1px solid rgba(255,255,255,0.1)",flexShrink:0}}>{footer}</div>}
    </div>
  </div>
);

// ══════════════════════════════════════════════════════════════
// MAIN APP
// ══════════════════════════════════════════════════════════════
export default function App(){
  const w=useWidth(); const desk=w>=768;

  const[user,setUser]=useState(null);
  const[loginName,setLoginName]=useState(()=>{
    try{return localStorage.getItem("nailshine_remember_name")||"";}catch(e){return "";}
  });
  const[loginPin,setLoginPin]=useState(()=>{
    try{return localStorage.getItem("nailshine_remember_pin")||"";}catch(e){return "";}
  });
  const[rememberMe,setRememberMe]=useState(()=>{
    try{return localStorage.getItem("nailshine_remember")==="1";}catch(e){return false;}
  });
  const[loginError,setLoginError]=useState("");
  const[loginBusy,setLoginBusy]=useState(false);

  const[tab,setTab]=useState("cal");
  const[co,setCo]=useState(null);
  const[time,setTime]=useState(new Date());
  const[liveEvents,setLiveEvents]=useState([]);
  const[roster,setRoster]=useState(["Eunice","Yan","Zoe","Sonia"]);
  const[isLoading,setIsLoading]=useState(true);
  const[serverDrafts,setServerDrafts]=useState({byEventId:{},byName:{}});
  const[serverLogs,setServerLogs]=useState([]);
  // "ok" | "degraded" (sheet wrote but Postgres didn't) | "offline"
  const[syncState,setSyncState]=useState("ok");

  const fetchDrafts=async()=>{
    try{
      const res=await fetch('/api/drafts/pg');
      const data=await res.json();
      if(data.drafts){
        const byEventId={};
        const byName={};  // fallback for drafts with no event_id
        data.drafts.forEach(d=>{
          if(d.calendar_event_id){
            if(!byEventId[d.calendar_event_id]) byEventId[d.calendar_event_id]=[];
            byEventId[d.calendar_event_id].push(d);
          }else{
            const baseName=(d.client_name||"").replace(/\s*\+\d+$/, "").toLowerCase().trim();
            if(!baseName) return;
            if(!byName[baseName]) byName[baseName]=[];
            byName[baseName].push(d);
          }
        });
        setServerDrafts({byEventId, byName});
        setSyncState(s=>s==="offline"?"ok":s);
      }
    }catch(e){
      console.error("fetchDrafts:",e);
      setSyncState("offline");
    }
  };

  const fetchLogs=async()=>{
    try{
      const res=await fetch('/api/logs');
      const data=await res.json();
      if(data.logs) setServerLogs(data.logs);
    }catch(e){console.error("fetchLogs:",e);}
  };

  const fetchSchedule=async()=>{
    try{
      const r=await fetch('/api/appointments/today');
      const data=await r.json();
      if(data.appointments){
        const formatted=data.appointments.map(e=>({
          t:e.time, n:e.client, s:e.client,
          colorId:e.color_id||"",
          eventId:e.event_id||"",
          techs:["Staff"], status:"tech"
        }));
        setLiveEvents(formatted);
        if(data.roster&&data.roster.length>0) setRoster(data.roster);
      }
      setIsLoading(false);
      setSyncState(s=>s==="offline"?"ok":s);
    }catch(e){ setIsLoading(false); setSyncState("offline"); }
  };

  useEffect(()=>{
    if(!user) return;

    const isBusinessHours=()=>{
      const n=new Date();
      const minutes=n.getHours()*60+n.getMinutes();
      return minutes>=510 && minutes<=1230; // 8:30 AM – 8:30 PM
    };

    const pollSchedule=()=>{if(isBusinessHours())fetchSchedule();};
    const pollDrafts  =()=>{if(isBusinessHours())fetchDrafts();};
    const pollLogs    =()=>{if(isBusinessHours())fetchLogs();};

    fetchSchedule();
    fetchDrafts();
    fetchLogs();

    const apptPoll=setInterval(pollSchedule,15000);
    const draftPoll=setInterval(pollDrafts,15000);
    const logPoll=setInterval(pollLogs,30000);
    const clock=setInterval(()=>setTime(new Date()),60000);
    return()=>{
      clearInterval(apptPoll);
      clearInterval(draftPoll);
      clearInterval(logPoll);
      clearInterval(clock);
    };
  },[user]);

  const STAFF_NAMES=["Nikki","Coco","Eunice","Rebecca","Sonia","Yan","Monica","Zoe","Cici"];

  const isAdmin = user?.role === "admin";
  const isTech  = user?.role === "tech";
  const nowHour = time.getHours();
  const techCanSeeCalendar = nowHour >= 9 && nowHour < 20;
  const showCalendar = isAdmin || techCanSeeCalendar;

  // Bounce a tech off the Calendar tab when the window closes.
  // In an effect, not during render — setTab() in the render body is a
  // render-phase state update and misbehaves under StrictMode.
  useEffect(()=>{
    if(isTech && !techCanSeeCalendar && tab==="cal") setTab("mysales");
  },[isTech,techCanSeeCalendar,tab]);

  const handlePinDigit=(digit)=>{
    if(digit==="⌫"){setLoginPin(p=>p.slice(0,-1));setLoginError("");return;}
    if(loginPin.length>=4) return;
    setLoginPin(p=>p+digit);
    setLoginError("");
  };

  const submitLogin=async()=>{
    if(loginBusy) return;
    if(!loginName){setLoginError("Pick a name first");return;}
    if(loginPin.length!==4){setLoginError("Enter 4-digit PIN");return;}
    setLoginBusy(true);setLoginError("");
    try{
      const res=await fetch("/api/login",{method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({name:loginName,pin:loginPin})});
      const data=await res.json();
      if(data.success){
        const u={role:data.role,name:data.name};
        setUser(u);
        try{
          if(rememberMe){
            localStorage.setItem("nailshine_remember","1");
            localStorage.setItem("nailshine_remember_name",loginName);
            localStorage.setItem("nailshine_remember_pin",loginPin);
          }else{
            localStorage.removeItem("nailshine_remember");
            localStorage.removeItem("nailshine_remember_name");
            localStorage.removeItem("nailshine_remember_pin");
          }
        }catch(e){}
        setLoginPin("");
      }else{
        setLoginError(data.error||"Login failed");
        setLoginPin("");
      }
    }catch(e){
      setLoginError("Connection error — try again");
    }
    setLoginBusy(false);
  };

  if(!user) return(
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0D0D0D,#1a1a2e,#0f3460)",
      display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Outfit',sans-serif",padding:"20px"}}>
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap" rel="stylesheet"/>
      <div style={{background:"rgba(255,255,255,0.04)",backdropFilter:"blur(20px)",borderRadius:28,
        padding:desk?"48px 44px":"40px 28px",border:"1px solid rgba(255,255,255,0.1)",textAlign:"center",
        width:desk?420:"100%",maxWidth:420}}>
        <div style={{fontSize:50,marginBottom:6}}>💅</div>
        <h1 style={{color:"#fff",fontSize:24,fontWeight:700,margin:"0 0 2px",letterSpacing:2}}>NAILSHINE</h1>
        <p style={{color:"rgba(255,255,255,0.55)",fontSize:11,margin:"0 0 24px",letterSpacing:3,textTransform:"uppercase"}}>Staff Portal</p>

        <div style={{marginBottom:14,textAlign:"left"}}>
          <label style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:700,letterSpacing:.8,textTransform:"uppercase",display:"block",marginBottom:6}}>Name</label>
          <select value={loginName} onChange={e=>{setLoginName(e.target.value);setLoginError("");}}
            style={{width:"100%",padding:"14px 16px",borderRadius:12,background:"rgba(255,255,255,0.07)",
              border:"1px solid rgba(255,255,255,0.15)",color:loginName?"#fff":"rgba(255,255,255,0.4)",
              fontSize:15,fontWeight:600,outline:"none",boxSizing:"border-box",
              appearance:"none",WebkitAppearance:"none",
              backgroundImage:"url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%23F4511E' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\")",
              backgroundRepeat:"no-repeat",backgroundPosition:"right 16px center",
              paddingRight:"40px"}}>
            <option value="" style={{background:"#1a1a2e",color:"#fff"}}>— Pick your name —</option>
            <option value="NAILSHINE" style={{background:"#1a1a2e",color:"#fff",fontWeight:700}}>🔑 NAILSHINE (Admin)</option>
            {STAFF_NAMES.map(n=>(
              <option key={n} value={n} style={{background:"#1a1a2e",color:"#fff"}}>{n}</option>
            ))}
          </select>
        </div>

        <div style={{marginBottom:14,textAlign:"left"}}>
          <label style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:700,letterSpacing:.8,textTransform:"uppercase",display:"block",marginBottom:6}}>4-Digit PIN</label>
          <div style={{display:"flex",gap:8,justifyContent:"center"}}>
            {[1,2,3,4].map(i=>(
              <div key={i} style={{width:46,height:54,borderRadius:12,
                background:loginPin.length>=i?(loginError?"rgba(231,76,60,0.2)":"rgba(244,81,30,0.2)"):"rgba(255,255,255,0.05)",
                border:`2px solid ${loginPin.length>=i?(loginError?"#E74C3C":"#F4511E"):"rgba(255,255,255,0.15)"}`,
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,
                color:loginError?"#E74C3C":"#F4511E",fontWeight:700,transition:"all 0.2s"}}>
                {loginPin.length>=i?"•":""}
              </div>
            ))}
          </div>
        </div>

        {loginError&&<div style={{fontSize:13,color:"#E74C3C",marginBottom:10,fontWeight:600}}>{loginError}</div>}

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,maxWidth:240,margin:"0 auto 16px"}}>
          {[1,2,3,4,5,6,7,8,9,"",0,"⌫"].map((n,i)=>n===""?<div key={i}/>:(
            <button key={i} onClick={()=>handlePinDigit(String(n))}
              style={{width:"100%",height:50,borderRadius:12,background:"rgba(255,255,255,0.06)",
                border:"1px solid rgba(255,255,255,0.1)",color:"#fff",fontSize:20,fontWeight:500,cursor:"pointer"}}>
              {n}
            </button>
          ))}
        </div>

        <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,cursor:"pointer",justifyContent:"center"}}>
          <input type="checkbox" checked={rememberMe} onChange={e=>setRememberMe(e.target.checked)}
            style={{width:18,height:18,accentColor:"#F4511E",cursor:"pointer"}}/>
          <span style={{fontSize:13,color:"#fff",fontWeight:500}}>Remember me on this device</span>
        </label>

        <button onClick={submitLogin} disabled={loginBusy||!loginName||loginPin.length!==4}
          style={{width:"100%",padding:"15px",borderRadius:12,
            background:(loginBusy||!loginName||loginPin.length!==4)?"rgba(255,255,255,0.08)":"#F4511E",
            border:"none",color:"#fff",fontSize:15,fontWeight:700,
            cursor:(loginBusy||!loginName||loginPin.length!==4)?"default":"pointer",transition:"all .15s"}}>
          {loginBusy?"Signing in…":"🔓 Login"}
        </button>
      </div>
    </div>
  );

  const navs=[
    ...(showCalendar ? [{id:"cal", ic:"📅", lb:"Calendar"}] : []),
    {id:"sani", ic:"🧴", lb:"Sanitation"},
    {id:"clean",ic:"🧹", lb:"Cleaning"},
    {id:"wi",   ic:"🚶", lb:"Walk-in"},
    isAdmin
      ? {id:"log", ic:"📊", lb:"Log"}
      : {id:"mysales", ic:"💰", lb:`${user.name}'s Sales`},
    {id:"june", ic:"🤖", lb:"June AI"},
  ];

  const SyncDot=()=>{
    const cfg=syncState==="ok"
      ?{c:"#2ECC71",t:"All changes saved"}
      :syncState==="degraded"
        ?{c:"#F6BF26",t:"Saved to the sheet, but not to the app — tell Rich"}
        :{c:"#E74C3C",t:"No connection to the server"};
    return(
      <div title={cfg.t} style={{display:"flex",alignItems:"center",gap:6}}>
        <div style={{width:8,height:8,borderRadius:"50%",background:cfg.c,flexShrink:0,
          boxShadow:syncState==="ok"?"none":`0 0 8px ${cfg.c}`}}/>
        {syncState!=="ok"&&<span style={{fontSize:10,color:cfg.c,fontWeight:700}}>
          {syncState==="degraded"?"SHEET ONLY":"OFFLINE"}
        </span>}
      </div>
    );
  };

  return(
    <div style={{minHeight:"100vh",background:"#0A0A0A",fontFamily:"'Outfit',sans-serif",color:"#fff",
      display:desk?"flex":"block"}}>
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap" rel="stylesheet"/>

      {desk&&(
        <div style={{width:230,minHeight:"100vh",background:"rgba(255,255,255,0.03)",
          borderRight:"1px solid rgba(255,255,255,0.08)",padding:"20px 14px",display:"flex",
          flexDirection:"column",position:"fixed",left:0,top:0,overflow:"auto"}}>
          <div style={{marginBottom:24}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <h1 style={{margin:0,fontSize:18,fontWeight:700,letterSpacing:1.5,color:"#fff"}}>💅 NAILSHINE</h1>
              <SyncDot/>
            </div>
            <p style={{margin:"4px 0 0",fontSize:11,color:"rgba(255,255,255,0.6)"}}>
              {time.toLocaleDateString("en-CA",{weekday:"long",month:"short",day:"numeric"})}
            </p>
          </div>
          <div style={{marginBottom:20}}>
            <p style={{fontSize:10,color:"rgba(255,255,255,0.5)",margin:"0 0 6px",textTransform:"uppercase",letterSpacing:1,fontWeight:600}}>Working Today</p>
            {roster.map(t=>(
              <div key={t} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 6px"}}>
                <Dot name={t} sz={22}/>
                <span style={{fontSize:13,color:"#fff",fontWeight:500}}>{t}</span>
              </div>
            ))}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:2}}>
            {navs.filter(n=>n.id!=="wi").map(n=>(
              <button key={n.id} onClick={()=>{setTab(n.id);setCo(null);}}
                style={{display:"flex",alignItems:"center",gap:9,padding:"10px 10px",borderRadius:9,
                  background:tab===n.id&&!co?"rgba(244,81,30,0.15)":"transparent",
                  border:`1px solid ${tab===n.id&&!co?"rgba(244,81,30,0.3)":"transparent"}`,
                  cursor:"pointer",width:"100%",textAlign:"left",
                  color:tab===n.id&&!co?"#F4511E":"#fff",transition:"all .12s",fontSize:13}}>
                <span style={{fontSize:17}}>{n.ic}</span>
                <span style={{fontWeight:tab===n.id&&!co?700:500}}>{n.lb}</span>
              </button>
            ))}
            <div style={{margin:"8px 0",borderTop:"1px solid rgba(255,255,255,0.08)"}}/>
            <button onClick={()=>setCo({isWalkin:true,cn:"",tech:roster[0]})}
              style={{display:"flex",alignItems:"center",gap:9,padding:"10px 10px",borderRadius:9,
                background:"rgba(244,81,30,0.1)",border:"1px solid rgba(244,81,30,0.25)",
                cursor:"pointer",width:"100%",textAlign:"left",color:"#F4511E",fontSize:13}}>
              <span style={{fontSize:17}}>🚶</span>
              <span style={{fontWeight:700}}>Walk-in</span>
            </button>
          </div>
          <div style={{marginTop:"auto",paddingTop:12}}>
            <button onClick={()=>{setUser(null);}}
              style={{background:"none",border:"none",color:"rgba(255,255,255,0.5)",fontSize:12,
                cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
              🔒 <span>Lock Screen</span>
            </button>
          </div>
        </div>
      )}

      {!desk&&(
        <div style={{padding:"12px 16px 10px",borderBottom:"1px solid rgba(255,255,255,0.1)",
          display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,
          background:"rgba(255,255,255,0.02)"}}>
          <div style={{minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <h1 style={{margin:0,fontSize:15,fontWeight:700,letterSpacing:1,color:"#fff"}}>NAILSHINE</h1>
              <SyncDot/>
            </div>
            <p style={{margin:0,fontSize:11,color:"rgba(255,255,255,0.65)"}}>
              {time.toLocaleDateString("en-CA",{weekday:"short",month:"short",day:"numeric"})}
            </p>
          </div>
          <RosterDots roster={roster} max={5} sz={26}/>
        </div>
      )}

      <div style={{marginLeft:desk?230:0,paddingBottom:desk?0:76,width:"100%",minHeight:"100vh"}}>
        {co
          ?<CashoutView key={co.cn+(co.allDrafts?.length||0)} co={co}
              close={()=>{setCo(null);fetchDrafts();fetchLogs();}}
              roster={roster} desk={desk} fetchDrafts={fetchDrafts} fetchLogs={fetchLogs}
              evts={liveEvents} serverDrafts={serverDrafts} onSync={setSyncState}/>
          :tab==="cal"    ?<CalView roster={roster} onCo={setCo} desk={desk} evts={liveEvents}
              loading={isLoading} serverDrafts={serverDrafts}/>
          :tab==="sani"   ?<SaniView roster={roster} desk={desk}/>
          :tab==="clean"  ?<CleanView roster={roster} desk={desk}/>
          :tab==="log"    ?(isAdmin?<LogView logs={serverLogs} setLogs={setServerLogs} desk={desk}/>:null)
          :tab==="mysales"?(isTech?<MySalesView techName={user.name} desk={desk}/>:null)
          :tab==="june"   ?<JuneView desk={desk}/>
          :null}
      </div>

      {!desk&&!co&&(
        <div style={{position:"fixed",bottom:0,left:0,right:0,background:"rgba(10,10,10,0.98)",
          backdropFilter:"blur(20px)",borderTop:"1px solid rgba(255,255,255,0.1)",
          display:"flex",justifyContent:"space-around",padding:"8px 0 18px"}}>
          {navs.map(n=>(
            <button key={n.id}
              onClick={()=>{
                if(n.id==="wi") setCo({isWalkin:true,cn:"",tech:roster[0]});
                else setTab(n.id);
              }}
              style={{background:"none",border:"none",cursor:"pointer",display:"flex",
                flexDirection:"column",alignItems:"center",gap:3,
                color:tab===n.id&&n.id!=="wi"?"#F4511E":"#fff",minWidth:44,padding:"4px 0"}}>
              <span style={{fontSize:20}}>{n.ic}</span>
              <span style={{fontSize:9,fontWeight:600}}>{n.lb}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// CALENDAR
// ══════════════════════════════════════════════════════════════

// Badge / colour config per draft status. GiftCard is blue, matching the
// row colour the backend paints on the sheet.
const STATUS_STYLE={
  cash:    {icon:"💵",label:"CASH",  color:"#2ECC71",bg:"rgba(46,204,113,0.18)", border:"rgba(46,204,113,0.4)", card:"rgba(46,204,113,0.07)",cardBorder:"rgba(46,204,113,0.25)",hover:"rgba(46,204,113,0.12)"},
  card:    {icon:"💳",label:"CARD",  color:"#E74C3C",bg:"rgba(231,76,60,0.18)",  border:"rgba(231,76,60,0.4)",  card:"rgba(231,76,60,0.07)", cardBorder:"rgba(231,76,60,0.25)", hover:"rgba(231,76,60,0.12)"},
  giftcard:{icon:"🎁",label:"GIFT",  color:"#039BE5",bg:"rgba(3,155,229,0.18)",  border:"rgba(3,155,229,0.4)",  card:"rgba(3,155,229,0.07)", cardBorder:"rgba(3,155,229,0.25)", hover:"rgba(3,155,229,0.12)"},
  draft:   {icon:"📋",label:"DRAFT", color:"#F6BF26",bg:"rgba(246,191,38,0.18)", border:"rgba(246,191,38,0.4)", card:"rgba(246,191,38,0.07)",cardBorder:"rgba(246,191,38,0.25)",hover:"rgba(246,191,38,0.12)"},
};
const styleFor=(s)=>STATUS_STYLE[s]||STATUS_STYLE.draft;

function CalView({roster,onCo,desk,evts,loading,serverDrafts}){
  const[now,setNow]=useState(new Date());
  useEffect(()=>{const t=setInterval(()=>setNow(new Date()),15000);return()=>clearInterval(t);},[]);

  const parseTime=(tStr)=>{
    try{
      const m=tStr.match(/(\d+):(\d+)\s*(AM|PM)/i);if(!m)return null;
      let h=parseInt(m[1]),mn=parseInt(m[2]),ap=m[3].toUpperCase();
      if(ap==="PM"&&h!==12)h+=12;if(ap==="AM"&&h===12)h=0;
      const d=new Date();d.setHours(h,mn,0,0);return d;
    }catch{return null;}
  };

  const nowStr=now.toLocaleTimeString("en-CA",{hour:"numeric",minute:"2-digit",hour12:true});
  const g={};evts.forEach(e=>{if(!g[e.t])g[e.t]=[];g[e.t].push(e);});
  const timeSlots=Object.entries(g);

  const slotsWithStatus=timeSlots.map(([tm,es])=>{
    const slotTime=parseTime(tm);
    const diffMin=slotTime?(slotTime-now)/60000:null;
    const isPast=diffMin!==null&&diffMin<-30;
    return{tm,es,isPast,slotTime,diffMin};
  });

  let nowDividerIdx=-1;
  for(let i=0;i<slotsWithStatus.length;i++){
    if(!slotsWithStatus[i].isPast){nowDividerIdx=i;break;}
  }
  if(nowDividerIdx===-1&&slotsWithStatus.length>0) nowDividerIdx=slotsWithStatus.length;

  const parseEvent=(e)=>{
    const raw=e.n||"";const colorId=e.colorId||"";
    const dashIdx=raw.indexOf(" - ");
    const clientName=dashIdx>-1?raw.substring(0,dashIdx).trim():raw.trim();
    const serviceRaw=dashIdx>-1?raw.substring(dashIdx+3):"";
    const cancelled=colorId==="7";
    let techs=[];
    const colorTech=COLOR_ID_TO_TECH[colorId];
    if(colorTech&&colorTech!=="CANCELLED"){techs=[colorTech];}
    else if(!cancelled){
      const wMatch=serviceRaw.match(/\bw\/\s*(.+?)(?:\s*$)/i);
      if(wMatch){
        const techStr=wMatch[1].trim();
        if(!/no\s*pref/i.test(techStr)){
          techStr.split(/[+&/,]+/).map(s=>s.trim()).forEach(p=>{
            const match=roster.find(r=>r.toLowerCase()===p.toLowerCase());
            if(match) techs.push(match);
          });
        }
      }
    }
    const serviceName=serviceRaw.replace(/\s*\bw\/\s*.+$/i,"").trim().replace(/\s+/g," ");
    const borderColor=cancelled?"#039BE5":COLOR_ID_HEX[colorId]||(techs.length>0?(TC[techs[0]]||{bg:"#2d2d3a"}).bg:"#2d2d3a");

    // Match drafts by calendar event_id first. The name fallback only exists
    // for rows written before per-person event_ids — and it deliberately
    // SKIPS "Walk-in", because every unnamed walk-in shares that name and
    // they would all group into one fake split bill.
    const eventId=e.eventId||"";
    let drafts=null;
    if(eventId && serverDrafts.byEventId && serverDrafts.byEventId[eventId]){
      drafts=serverDrafts.byEventId[eventId];
    } else if(serverDrafts.byName){
      const key=clientName.toLowerCase().trim();
      if(key && key!=="walk-in" && !key.startsWith("walk-in ")){
        drafts=serverDrafts.byName[key]||null;
      }
    }

    const hasDraft=!!(drafts&&drafts.length>0);
    const draft=hasDraft?drafts[0]:null;
    const draftCount=hasDraft?drafts.length:0;
    const isSplit=draftCount>1;
    const statuses=hasDraft?drafts.map(d=>d.status):[];
    const anyDraft=statuses.some(s=>s==="draft");
    const draftStatus=hasDraft?drafts[0].status:null;
    return{clientName,serviceName,techs,borderColor,cancelled,
      hasDraft,draft,draftStatus,draftCount,isSplit,statuses,anyDraft,
      allDrafts:drafts, eventId};
  };

  return(
    <div style={{padding:desk?"22px 32px":"14px 16px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:desk?22:16}}>
        <h2 style={{margin:0,fontSize:desk?22:18,fontWeight:700,color:"#fff"}}>Today's Schedule</h2>
        <span style={{fontSize:12,color:"rgba(255,255,255,0.65)",fontWeight:500}}>
          {loading?"Syncing…":`${evts.length} appointments`}
        </span>
      </div>

      {loading&&(
        <div style={{textAlign:"center",padding:"60px 0",color:"rgba(255,255,255,0.5)"}}>
          <div style={{fontSize:36,marginBottom:12}}>🔄</div>
          <div style={{fontSize:14,fontWeight:500}}>Fetching from Google Calendar…</div>
        </div>
      )}

      {!loading&&evts.length===0&&(
        <div style={{textAlign:"center",padding:"60px 0",color:"rgba(255,255,255,0.4)"}}>
          <div style={{fontSize:40,marginBottom:12,opacity:.6}}>📭</div>
          <div style={{fontSize:15,fontWeight:500}}>No appointments today</div>
        </div>
      )}

      {!loading&&slotsWithStatus.map(({tm,es,isPast},idx)=>(
        <React.Fragment key={tm}>
          {idx===nowDividerIdx&&(
            <div style={{display:"flex",alignItems:"center",gap:10,margin:"12px 0 16px"}}>
              <div style={{flex:1,height:2,background:"linear-gradient(90deg,#F4511E,rgba(244,81,30,0))"}}/>
              <div style={{background:"#F4511E",color:"#fff",fontSize:11,fontWeight:700,letterSpacing:1,
                padding:"4px 12px",borderRadius:20,whiteSpace:"nowrap",
                boxShadow:"0 0 16px rgba(244,81,30,0.6)"}}>▶ NOW {nowStr}</div>
              <div style={{flex:1,height:2,background:"linear-gradient(90deg,rgba(244,81,30,0),#F4511E)"}}/>
            </div>
          )}
          <div style={{marginBottom:desk?18:14}}>
            <div style={{fontSize:12,fontWeight:700,
              color:isPast?"rgba(255,255,255,0.45)":"rgba(255,255,255,0.8)",
              marginBottom:7,paddingLeft:4,letterSpacing:.8,
              display:"flex",alignItems:"center",gap:8}}>
              <span>{tm}</span>
              {isPast&&<span style={{fontSize:10,color:"rgba(255,255,255,0.4)",fontWeight:500}}>past</span>}
              <div style={{flex:1,height:1,background:"rgba(255,255,255,0.08)"}}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:desk?"repeat(auto-fill,minmax(310px,1fr))":"1fr",gap:7}}>
              {es.map((e,i)=>{
                const{clientName,serviceName,techs,borderColor,cancelled,hasDraft,draft,draftStatus,draftCount,isSplit,statuses,anyDraft,allDrafts,eventId}=parseEvent(e);
                const hasTech=techs.length>0;
                const st=styleFor(draftStatus);

                let badgeText=null,badgeBg,badgeBorder,badgeColor;
                if(hasDraft){
                  if(isSplit){
                    if(anyDraft){
                      badgeText=`📋 SPLIT (${draftCount})`;
                      badgeBg=STATUS_STYLE.draft.bg;badgeBorder=STATUS_STYLE.draft.border;badgeColor=STATUS_STYLE.draft.color;
                    } else {
                      const icons=statuses.map(s=>styleFor(s).icon).join(" ");
                      badgeText=`${icons} SPLIT (${draftCount})`;
                      badgeBg="rgba(255,255,255,0.1)";badgeBorder="rgba(255,255,255,0.25)";badgeColor="#fff";
                    }
                  } else {
                    badgeText=`${st.icon} ${st.label}`;
                    badgeBg=st.bg;badgeBorder=st.border;badgeColor=st.color;
                  }
                }

                const cardBg=cancelled?"rgba(3,155,229,0.07)":
                  !hasDraft?"rgba(255,255,255,0.04)":
                  isSplit?"rgba(255,255,255,0.05)":st.card;
                const cardBorder=cancelled?"rgba(3,155,229,0.2)":
                  !hasDraft?"rgba(255,255,255,0.1)":
                  isSplit?"rgba(255,255,255,0.15)":st.cardBorder;
                const leftBorderColor=!hasDraft?borderColor:
                  isSplit?STATUS_STYLE.draft.color:st.color;
                const tapHint=isSplit?`Tap to view split (${draftCount} people) →`:
                  hasDraft?`Tap to view ${st.label.toLowerCase()} ticket →`:"Tap to load draft →";

                return(
                  <button key={i}
                    onClick={()=>{
                      if(cancelled&&!draft) return;
                      onCo({cn:clientName,tech:techs[0]||"Staff",calSvc:serviceName,
                        techs:hasTech?techs:["Staff"],
                        postDraft:draft||null,allDrafts:allDrafts||null,
                        eventId});
                    }}
                    style={{background:cardBg,border:`1px solid ${cardBorder}`,
                      borderLeft:`6px solid ${leftBorderColor}`,
                      borderRadius:10,padding:"12px 14px",display:"flex",alignItems:"center",
                      justifyContent:"space-between",cursor:cancelled&&!draft?"default":"pointer",
                      width:"100%",textAlign:"left",transition:"background .1s"}}
                    onMouseEnter={x=>{if(!cancelled)x.currentTarget.style.background=
                      hasDraft?(isSplit?"rgba(255,255,255,0.08)":st.hover):"rgba(255,255,255,0.08)";}}
                    onMouseLeave={x=>{if(!cancelled)x.currentTarget.style.background=cardBg;}}>
                    <div style={{flex:1,minWidth:0,paddingRight:hasTech&&!cancelled?10:0}}>
                      <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:serviceName?4:0}}>
                        <div style={{fontSize:desk?15:14,fontWeight:700,
                          color:cancelled?"rgba(255,255,255,0.4)":"#fff",
                          textDecoration:cancelled?"line-through":"none",
                          overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                          {clientName||e.n}
                        </div>
                        {badgeText&&(
                          <div style={{flexShrink:0,background:badgeBg,
                            border:`1px solid ${badgeBorder}`,borderRadius:5,
                            padding:"2px 7px",fontSize:9,fontWeight:700,color:badgeColor,
                            letterSpacing:.5,whiteSpace:"nowrap"}}>{badgeText}</div>
                        )}
                      </div>
                      {serviceName&&(
                        <div style={{fontSize:12,color:cancelled?"rgba(255,255,255,0.35)":"rgba(255,255,255,0.75)",
                          overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontWeight:500}}>
                          {serviceName}
                        </div>
                      )}
                      {cancelled&&(
                        <div style={{fontSize:11,fontWeight:700,color:"#039BE5",marginTop:3,letterSpacing:.5}}>
                          CANCELLED
                        </div>
                      )}
                      {hasDraft&&(
                        <div style={{fontSize:11,color:badgeColor,marginTop:3,fontWeight:500,opacity:.8}}>
                          {tapHint}
                        </div>
                      )}
                    </div>
                    {hasTech&&!cancelled&&(
                      <div style={{display:"flex",gap:4,flexShrink:0}}>
                        {techs.map((t,j)=><Dot key={j} name={t} sz={28}/>)}
                      </div>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// SANITATION
// ══════════════════════════════════════════════════════════════
function SaniView({roster,desk}){
  const[times,setTimes]=useState({});
  const[loading,setLoading]=useState(true);
  const getKey=(tech,type)=>`${tech}_${type}`;

  const fetchState=async()=>{
    try{
      const res=await fetch("/api/sanitation");
      const data=await res.json();
      if(data.state) setTimes(data.state);
    }catch(e){console.error("sanitation fetch:",e);}
    setLoading(false);
  };

  useEffect(()=>{
    fetchState();
    const poll=setInterval(fetchState,15000);
    return()=>clearInterval(poll);
  },[]);

  const handleClick=async(tech,type)=>{
    const key=getKey(tech,type);
    const wasChecked=!!times[key];

    if(wasChecked){
      const prev=times[key];
      setTimes(p=>{const n={...p};delete n[key];return n;});
      try{
        const res=await fetch("/api/sanitation",{method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({tech,type,clear:true})});
        const data=await res.json();
        if(!data.success){
          setTimes(p=>({...p,[key]:prev}));
          alert(`Could not clear: ${data.error}`);
        }
      }catch(e){
        setTimes(p=>({...p,[key]:prev}));
        console.error("Sanitation clear:",e);
      }
      return;
    }

    const timeStr=new Date().toLocaleTimeString("en-CA",{hour:"numeric",minute:"2-digit",hour12:true});
    setTimes(p=>({...p,[key]:timeStr}));
    try{
      const res=await fetch("/api/sanitation",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({tech,type,time:timeStr})});
      const data=await res.json();
      if(!data.success){
        setTimes(p=>{const n={...p};delete n[key];return n;});
        alert(`Sheet write failed for ${tech}: ${data.error}`);
      }
    }catch(e){
      setTimes(p=>{const n={...p};delete n[key];return n;});
      console.error("Sanitation POST:",e);
    }
  };

  const Check=({tech,type,label})=>{
    const key=getKey(tech,type);const checked=!!times[key];const timeVal=times[key];
    return(
      <button onClick={()=>handleClick(tech,type)}
        style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:9,
          background:checked?"rgba(46,204,113,0.12)":"rgba(255,255,255,0.05)",
          border:`1px solid ${checked?"rgba(46,204,113,0.3)":"rgba(255,255,255,0.1)"}`,
          cursor:"pointer",width:"100%",textAlign:"left",transition:"all .12s"}}>
        <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${checked?"#2ECC71":"rgba(255,255,255,0.3)"}`,
          background:checked?"#2ECC71":"transparent",display:"flex",alignItems:"center",
          justifyContent:"center",fontSize:13,color:"#fff",flexShrink:0,fontWeight:700}}>
          {checked?"✓":""}
        </div>
        <div>
          <div style={{fontSize:13,color:checked?"#2ECC71":"#fff",fontWeight:600}}>{label}</div>
          {timeVal&&<div style={{fontSize:11,color:"rgba(255,255,255,0.55)",fontWeight:500}}>{timeVal}</div>}
        </div>
      </button>
    );
  };

  const Section=({title,row,type1,type2,label1,label2})=>(
    <div style={{marginBottom:24}}>
      <h3 style={{fontSize:12,fontWeight:700,color:"rgba(255,255,255,0.7)",margin:"0 0 12px",
        textTransform:"uppercase",letterSpacing:.8,display:"flex",alignItems:"center",gap:8}}>
        <span>{title}</span>
        <span style={{fontSize:10,color:"rgba(255,255,255,0.4)",fontWeight:500,textTransform:"none"}}>— Row {row}</span>
      </h3>
      <div style={{display:desk?"grid":"flex",gridTemplateColumns:desk?"1fr 1fr":undefined,
        flexDirection:desk?undefined:"column",gap:8}}>
        {roster.map(t=>(
          <div key={t} style={{background:"rgba(255,255,255,0.04)",borderRadius:12,padding:12,
            border:"1px solid rgba(255,255,255,0.09)"}}>
            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:8}}>
              <Dot name={t} sz={22}/>
              <span style={{fontSize:14,fontWeight:700,color:"#fff"}}>{t}</span>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <Check tech={t} type={type1} label={label1}/>
              <Check tech={t} type={type2} label={label2}/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return(
    <div style={{padding:desk?"22px 32px":"14px 16px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <h2 style={{margin:0,fontSize:desk?22:18,fontWeight:700,color:"#fff"}}>🧴 Sanitation Log</h2>
        <span style={{fontSize:11,color:"rgba(255,255,255,0.5)",fontWeight:500}}>
          {loading?"Syncing…":"Auto-syncs every 15s"}
        </span>
      </div>
      <Section title="Individual Disinfectant (1000ppm)" row={3}
        type1="individual_made" type2="individual_discarded"
        label1="Morning — Made" label2="Evening — Discarded"/>
      <Section title="High Level Disinfectant (5000ppm)" row={2}
        type1="high_made" type2="high_discarded"
        label1="Made" label2="Discarded"/>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// CLEANING
// NOTE: this view is local-only. Assignments reshuffle and ticks clear
// whenever the tab is left, because there is no server endpoint behind it.
// The banner says so rather than letting it look like a saved record.
// ══════════════════════════════════════════════════════════════
function CleanView({roster,desk}){
  const[assignments,setAssignments]=useState(null);
  const[done,setDone]=useState({});

  const shuffle=()=>{
    const tasks=[...CLEAN_TASKS];const techs=[...roster];
    const a={};tasks.forEach((task,i)=>{a[task]=techs[i%techs.length];});
    setAssignments(a);setDone({});
  };

  useEffect(()=>{if(!assignments)shuffle();},[]);// eslint-disable-line

  const doneCount=Object.values(done).filter(Boolean).length;
  const total=CLEAN_TASKS.length;

  return(
    <div style={{padding:desk?"22px 32px":"14px 16px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div>
          <h2 style={{margin:0,fontSize:desk?22:18,fontWeight:700,color:"#fff"}}>🧹 Cleaning</h2>
          <p style={{margin:"3px 0 0",fontSize:12,color:"rgba(255,255,255,0.6)",fontWeight:500}}>
            {doneCount}/{total} complete
          </p>
        </div>
        <button onClick={shuffle}
          style={{padding:"8px 16px",borderRadius:9,background:"rgba(255,255,255,0.07)",
            border:"1px solid rgba(255,255,255,0.15)",color:"#fff",fontSize:12,
            cursor:"pointer",fontWeight:600}}>
          🔄 Re-shuffle
        </button>
      </div>
      <div style={{padding:"8px 12px",borderRadius:9,background:"rgba(246,191,38,0.08)",
        border:"1px solid rgba(246,191,38,0.2)",marginBottom:14,
        fontSize:11,color:"#F6BF26",fontWeight:600}}>
        Not saved — this list resets when you leave the tab.
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:7}}>
        {assignments&&Object.entries(assignments).map(([task,tech])=>(
          <button key={task}
            onClick={()=>setDone(p=>({...p,[task]:p[task]?null:new Date().toLocaleTimeString("en-CA",{hour:"numeric",minute:"2-digit"})}))}
            style={{display:"flex",alignItems:"center",justifyContent:"space-between",
              padding:"13px 16px",borderRadius:11,
              background:done[task]?"rgba(46,204,113,0.09)":"rgba(255,255,255,0.04)",
              border:`1px solid ${done[task]?"rgba(46,204,113,0.22)":"rgba(255,255,255,0.09)"}`,
              cursor:"pointer",width:"100%",textAlign:"left",transition:"all .12s"}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:24,height:24,borderRadius:7,
                border:`2px solid ${done[task]?"#2ECC71":"rgba(255,255,255,0.3)"}`,
                background:done[task]?"#2ECC71":"transparent",display:"flex",
                alignItems:"center",justifyContent:"center",fontSize:13,color:"#fff",fontWeight:700}}>
                {done[task]?"✓":""}
              </div>
              <div>
                <div style={{fontSize:14,fontWeight:600,color:done[task]?"rgba(255,255,255,0.4)":"#fff",
                  textDecoration:done[task]?"line-through":"none"}}>{task}</div>
                {done[task]&&<div style={{fontSize:11,color:"rgba(255,255,255,0.5)",fontWeight:500}}>{done[task]}</div>}
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:7}}>
              <Dot name={tech} sz={24}/>
              <span style={{fontSize:12,color:"rgba(255,255,255,0.7)",fontWeight:600}}>{tech}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// JUNE AI
// The system prompt now lives on the server (/api/june). It used to be
// sent from here, which meant anyone with the URL could run their own
// prompt on the salon's Gemini key.
// ══════════════════════════════════════════════════════════════
function JuneView({desk}){
  const[messages,setMessages]=useState([{role:"assistant",content:"Hi! I'm June 💅 Ask me anything about health & safety, disinfection protocols, or client questions — in English or 中文!"}]);
  const[input,setInput]=useState("");
  const[loading,setLoading]=useState(false);
  const msgEndRef=React.useRef(null);

  useEffect(()=>{msgEndRef.current?.scrollIntoView({behavior:"smooth"});},[messages]);

  const send=async(overrideText)=>{
    const text=(overrideText!==undefined?overrideText:input).trim();
    if(!text||loading) return;
    setInput("");
    const userMsg={role:"user",content:text};
    const newMessages=[...messages,userMsg];
    setMessages(newMessages);setLoading(true);
    try{
      const res=await fetch("/api/june",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({messages:newMessages.map(m=>({role:m.role,content:m.content}))})});
      const data=await res.json();
      setMessages(p=>[...p,{role:"assistant",content:data.reply||data.error||"Sorry, couldn't get a response."}]);
    }catch(e){
      setMessages(p=>[...p,{role:"assistant",content:"Connection error — try again 😅"}]);
    }
    setLoading(false);
  };

  const chips=["菜单 / Menu","如何配制1000ppm?","一次性用品有哪些?","蜡疗双蘸规定?","检查员检查什么?","足浴盆如何消毒?"];

  return(
    <div style={{display:"flex",flexDirection:"column",height:desk?"calc(100vh)":"calc(100vh - 124px)",
      maxWidth:desk?720:"100%",margin:desk?"0 auto":"0",width:"100%"}}>
      <div style={{padding:"16px 20px",borderBottom:"1px solid rgba(255,255,255,0.1)",flexShrink:0,
        background:"rgba(255,255,255,0.02)"}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{fontSize:30}}>🤖</div>
          <div>
            <div style={{fontSize:16,fontWeight:700,color:"#fff"}}>June AI</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:500}}>Health & Safety · EN / 中文</div>
          </div>
        </div>
      </div>
      <div style={{flex:1,overflow:"auto",padding:"16px",display:"flex",flexDirection:"column",gap:10}}>
        {messages.map((m,i)=>(
          <div key={i} style={{display:"flex",justifyContent:m.role==="user"?"flex-end":"flex-start"}}>
            <div style={{maxWidth:"84%",padding:"11px 15px",
              borderRadius:m.role==="user"?"16px 16px 4px 16px":"16px 16px 16px 4px",
              background:m.role==="user"?"#F4511E":"rgba(255,255,255,0.09)",
              color:"#fff",fontSize:13,lineHeight:1.6,whiteSpace:"pre-wrap",wordBreak:"break-word",
              fontWeight:400}}>
              {m.content}
            </div>
          </div>
        ))}
        {loading&&(
          <div style={{display:"flex",justifyContent:"flex-start"}}>
            <div style={{padding:"11px 16px",borderRadius:"16px 16px 16px 4px",
              background:"rgba(255,255,255,0.07)",fontSize:13,color:"rgba(255,255,255,0.6)",fontWeight:500}}>
              June is thinking…
            </div>
          </div>
        )}
        <div ref={msgEndRef}/>
      </div>
      <div style={{padding:"8px 16px",display:"flex",gap:6,overflowX:"auto",flexShrink:0}}>
        {chips.map(c=>(
          <button key={c} onClick={()=>send(c)}
            style={{padding:"6px 13px",borderRadius:16,whiteSpace:"nowrap",
              background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.15)",
              color:"#fff",fontSize:11,cursor:"pointer",flexShrink:0,fontWeight:500}}>
            {c}
          </button>
        ))}
      </div>
      <div style={{padding:"10px 16px 16px",borderTop:"1px solid rgba(255,255,255,0.1)",
        flexShrink:0,display:"flex",gap:8}}>
        <input value={input} onChange={e=>setInput(e.target.value)}
          onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();send();}}}
          placeholder="Ask June anything… / 用中文提问"
          style={{flex:1,padding:"12px 15px",borderRadius:11,background:"rgba(255,255,255,0.07)",
            border:"1px solid rgba(255,255,255,0.15)",color:"#fff",fontSize:13,outline:"none",fontWeight:400}}/>
        <button onClick={()=>send()} disabled={!input.trim()||loading}
          style={{padding:"12px 18px",borderRadius:11,
            background:input.trim()&&!loading?"#F4511E":"rgba(255,255,255,0.08)",
            border:"none",color:"#fff",fontSize:13,fontWeight:700,
            cursor:input.trim()&&!loading?"pointer":"default",transition:"all .15s",flexShrink:0}}>
          Send
        </button>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// CASHOUT — multi-person split bill support
// ══════════════════════════════════════════════════════════════

function PersonTicket({personNum,baseName,nameSuffix,co,roster,desk,fetchDrafts,fetchLogs,
                       onRemove,showPicker,setShowPicker,evts,eventId,setEventId,onSync}){
  const[cn,setCn]=useState(()=>{
    if(co.isWalkin) return "Walk-in";
    // A restored split already knows its own name ("Dad +1") — the draft row
    // is the truth. Only fall back to base+suffix for a person added now.
    if(co.postDraft?.client_name) return co.postDraft.client_name;
    const base=co.cn||"";
    return nameSuffix?(base+" "+nameSuffix):base;
  });
  const[bookedWalkin,setBookedWalkin]=useState(false);
  const[booking,setBooking]=useState(false);
  const[bookError,setBookError]=useState(null);
  const[items,setItems]=useState(()=>{
    // Re-run the wax cut on load: drafts written before this version stored
    // wax with sc:0 and the full price as tech pay.
    if(co.postDraft&&co.postDraft.items) return applyWaxSc(co.postDraft.items);
    return[];
  });
  const[phone,setPhone]=useState("");
  const[tip,setTip]=useState("");
  const[cTip,setCTip]=useState("");
  const[confirmation,setConfirmation]=useState(null);
  const[submitting,setSubmitting]=useState(false);
  const[deleting,setDeleting]=useState(false);
  const[updating,setUpdating]=useState(false);
  const[postSheetRow,setPostSheetRow]=useState(co.postDraft?.sheet_row||null);
  const[postSheetTab,setPostSheetTab]=useState(co.postDraft?.sheet_tab||null);
  // Locked once the ticket is closed. Prevents a second CASH tap writing a
  // whole second row, and makes a finished ticket look finished.
  const[closedAs,setClosedAs]=useState(()=>{
    const s=co.postDraft?.status;
    return (s==="cash"||s==="card"||s==="giftcard")?s:null;
  });
  const[selected,setSelected]=useState({});
  const[cat,setCat]=useState("hands");
  const[customName,setCustomName]=useState("");
  const[customPrice,setCustomPrice]=useState("");
  const[customTech,setCustomTech]=useState(co.tech||roster[0]);
  const[addonSelections,setAddonSelections]=useState({});

  const toggleSelect=(name)=>setSelected(p=>{const n={...p};if(n[name])delete n[name];else n[name]={tech:null};return n;});
  const setSvcTech=(name,t)=>setSelected(p=>({...p,[name]:{...p[name],tech:t}}));
  const toggleCombo=(name)=>setSelected(p=>{const n={...p};if(n[name])delete n[name];else n[name]={handTech:null,feetTech:null};return n;});
  const setComboTech=(name,part,t)=>setSelected(p=>({...p,[name]:{...p[name],[part]:t}}));
  const toggleAddon=(key,name,price)=>setAddonSelections(p=>{const n={...p};if(n[key])delete n[key];else n[key]={name,price,tech:null};return n;});
  const setAddonTech=(key,t)=>setAddonSelections(p=>({...p,[key]:{...p[key],tech:t}}));

  const WhoRow=({label,value,onChange})=>(
    <div style={{padding:"10px 12px 12px",borderTop:"1px solid rgba(255,255,255,0.08)",background:"rgba(0,0,0,0.2)"}}>
      <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:700,textTransform:"uppercase",letterSpacing:.5,marginBottom:8}}>{label||"Who's doing it?"}</div>
      <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
        {roster.map(t=>{const c=TC[t]||{bg:"#666",tx:"#fff"};const active=value===t;return(
          <button key={t} onClick={()=>onChange(t)} style={{padding:"7px 14px",borderRadius:18,background:active?c.bg:"rgba(255,255,255,0.1)",border:`1px solid ${active?c.bg:"rgba(255,255,255,0.15)"}`,color:active?c.tx:"#fff",fontSize:13,fontWeight:active?700:500,cursor:"pointer",transition:"all .1s"}}>{t}</button>
        );})}
      </div>
    </div>
  );

  const applyPicker=()=>{
    const newItems=[];
    Object.entries(selected).forEach(([nm,sel])=>{
      const sv=SVC[nm];if(!sv)return;
      if(sv.cat==="combo"){
        const hTech=sel.handTech||roster[0];const fTech=sel.feetTech||roster[0];
        newItems.push({name:sv.handPart||"Hands",price:sv.handTp,sc:0,tp:sv.handTp,tech:hTech,ty:"s",comboOf:nm});
        newItems.push({name:sv.feetPart||"Feet",price:sv.feetTp,sc:0,tp:sv.feetTp,tech:fTech,ty:"s",comboOf:nm});
        if(sv.sc>0) newItems.push({name:"SC",price:sv.sc,sc:sv.sc,tp:0,tech:"Store",ty:"sc",comboOf:nm});
      }else{
        const t=sel.tech||roster[0];const svcSc=sv.sc==="wax"?0:sv.sc;
        newItems.push({name:nm,price:sv.p,sc:svcSc,tp:sv.tp,tech:t,ty:"s"});
      }
    });
    Object.entries(addonSelections).forEach(([k,a])=>{newItems.push({name:a.name,price:a.price,sc:0,tp:a.price,tech:a.tech||roster[0],ty:"a"});});
    if(customName.trim()&&customPrice){newItems.push({name:customName.trim(),price:parseFloat(customPrice)||0,sc:0,tp:parseFloat(customPrice)||0,tech:customTech,ty:"c"});}
    // Recompute wax SC across the whole ticket, not just this batch.
    setItems(p=>applyWaxSc([...p,...newItems]));
    setSelected({});setAddonSelections({});setCustomName("");setCustomPrice("");setShowPicker(false);
  };

  const rm=(i)=>setItems(p=>applyWaxSc(p.filter((_,x)=>x!==i)));

  // Wax SC is baked into items, so every total is a plain sum.
  const sub=items.reduce((a,i)=>a+i.price,0);
  const sc=items.reduce((a,i)=>a+(parseFloat(i.sc)||0),0);
  const tax=Math.round(sub*13)/100;
  const tot=Math.round((sub+tax)*100)/100;
  const tp={};
  items.forEach(i=>{if(i.ty==="sc")return;if(i.tech&&i.tech!=="Store")tp[i.tech]=(tp[i.tech]||0)+(parseFloat(i.tp)||0);});
  const fTip=cTip?parseFloat(cTip)||0:parseFloat(tip)||0;
  const selectedCount=Object.keys(selected).length+Object.keys(addonSelections).length+(customName.trim()&&customPrice?1:0);

  const noteSync=(data)=>{
    if(data && data.success && data.pg_ok===false) onSync&&onSync("degraded");
    else if(data && data.success) onSync&&onSync("ok");
  };

  const basePayload=(payment,totalValue)=>({
    client_name:cn,payment,tip:fTip,items,sub,tax,tot:totalValue,
    closedAt:new Date().toISOString(),id:Date.now(),
    calendar_event_id: eventId || null,
    ...(postSheetRow?{overwrite_row:postSheetRow}:{})
  });

  const handleBookWalkin=async()=>{
    if(booking)return;setBooking(true);setBookError(null);
    try{
      const services=items.filter(i=>i.ty==="s"||i.ty==="c").map(i=>i.name);
      const tech=items.find(i=>i.tech&&i.tech!=="Staff")?.tech||"Staff";
      const res=await fetch("/api/book-walkin",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({client_name:cn||"Walk-in",phone,services:services.length?services:["Walk-in"],tech})});
      const data=await res.json();
      if(data.success){
        setBookedWalkin(true);
        // Keep the event id. Without it every unnamed walk-in shares the
        // name "Walk-in" and they all collapse into one fake split bill.
        if(data.event_id) setEventId(data.event_id);
      }else{setBookError(data.error||"Booking failed");}
    }catch(e){setBookError("Could not reach server");}
    setBooking(false);
  };

  const handlePost=async()=>{
    if(submitting||items.length===0)return;setSubmitting(true);
    try{
      const res=await fetch("/api/cashout",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify(basePayload("POST",tot))});
      const data=await res.json();
      if(data.success){
        setPostSheetRow(data.sheet_row);setPostSheetTab(data.sheet_tab);
        setConfirmation({payment:"POST",sheetOk:true,sheetRow:data.sheet_row,sheetTab:data.sheet_tab,pgOk:data.pg_ok,pgError:data.pg_error});
        noteSync(data);
        fetchDrafts();
      }
      else{setConfirmation({payment:"POST",sheetOk:false,error:data.error});}
    }catch(e){setConfirmation({payment:"POST",sheetOk:false,error:"Could not reach server"});}
    setSubmitting(false);
  };

  const handleUpdate=async()=>{
    if(updating||!postSheetRow||items.length===0)return;setUpdating(true);
    const ticket={client_name:cn,payment:"UPDATE",tip:fTip,items,sub,tax,tot,
      closedAt:new Date().toISOString(),id:Date.now(),
      calendar_event_id: eventId || null,
      overwrite_row:postSheetRow,sheet_tab:postSheetTab};
    try{
      const res=await fetch("/api/cashout/update",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(ticket)});
      const data=await res.json();
      if(data.success){
        setConfirmation({payment:"UPDATE",sheetOk:true,sheetRow:data.sheet_row,sheetTab:data.sheet_tab,pgOk:data.pg_ok,pgError:data.pg_error});
        noteSync(data);
        fetchDrafts();
      }
      else{setConfirmation({payment:"UPDATE",sheetOk:false,error:data.error});}
    }catch(e){setConfirmation({payment:"UPDATE",sheetOk:false,error:"Could not reach server"});}
    setUpdating(false);
  };

  const handleDeleteDraft=async()=>{
    if(deleting||!postSheetRow)return;
    if(!window.confirm(`Delete this ticket for ${cn}? This cannot be undone.`)) return;
    setDeleting(true);
    try{
      const res=await fetch("/api/drafts/delete",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({sheet_row:postSheetRow,sheet_tab:postSheetTab,
          ticket_id:co.postDraft?.ticket_id||null})});
      const data=await res.json();
      if(data.success){
        await fetchDrafts();
        if(onRemove){
          onRemove();
        }else{
          const backBtn=document.querySelector('[data-back-button]');
          if(backBtn){backBtn.click();}
          else{window.history.back();}
        }
      }else{
        alert("Could not delete: "+(data.error||"unknown error"));
      }
    }catch(e){alert("Could not reach server");}
    setDeleting(false);
  };

  // Cash is recorded without tax; Card and Gift Card carry the taxed total.
  const handleClose=async(payment)=>{
    if(submitting||closedAs)return;setSubmitting(true);
    const finalTot=payment==="Cash"?sub:tot;
    try{
      const res=await fetch("/api/cashout",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify(basePayload(payment,finalTot))});
      const data=await res.json();
      if(data.success){
        // Capture the row BEFORE anything else. Without this a second tap
        // posted with no overwrite_row and wrote a duplicate ticket.
        setPostSheetRow(data.sheet_row);setPostSheetTab(data.sheet_tab);
        setClosedAs(payment.toLowerCase()==="giftcard"?"giftcard":payment.toLowerCase());
        noteSync(data);
        fetchDrafts();fetchLogs();
      }
      setConfirmation({payment,sheetOk:data.success,sheetRow:data.sheet_row,
        sheetTab:data.sheet_tab,error:data.error,pgOk:data.pg_ok,pgError:data.pg_error});
    }catch(e){setConfirmation({payment,sheetOk:false,error:"Could not reach server"});}
    setSubmitting(false);
  };

  const ConfirmBanner=()=>{
    if(!confirmation)return null;
    const p=confirmation.payment;
    const isPost=p==="POST";const isUpdate=p==="UPDATE";
    const key=isUpdate?"update":isPost?"draft":p==="Cash"?"cash":p==="Card"?"card":"giftcard";
    const st=isUpdate
      ?{color:"#039BE5",bg:"rgba(3,155,229,0.1)",border:"rgba(3,155,229,0.3)",icon:"🔄"}
      :styleFor(key);
    const title=isUpdate?(confirmation.sheetOk?"Row Updated":"Update Failed")
      :isPost?(confirmation.sheetOk?"Posted as Draft":"Post Failed")
      :(confirmation.sheetOk?"Sheet Written":"Sheet Failed");
    return(
      <div style={{marginBottom:12}}>
        <div style={{padding:"12px 14px",borderRadius:10,
          background:st.bg||"rgba(255,255,255,0.06)",border:`1px solid ${st.border||"rgba(255,255,255,0.15)"}`}}>
          <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8}}>
            <div style={{display:"flex",alignItems:"flex-start",gap:8}}>
              <span style={{fontSize:18,lineHeight:1}}>{st.icon}</span>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:st.color}}>{title}</div>
                {confirmation.sheetRow&&<div style={{fontSize:10,color:"rgba(255,255,255,0.6)",marginTop:2}}>Row {confirmation.sheetRow} · Tab {confirmation.sheetTab}</div>}
                {!confirmation.sheetOk&&confirmation.error&&<div style={{fontSize:11,color:"#E74C3C",marginTop:3}}>{confirmation.error}</div>}
              </div>
            </div>
            <button onClick={()=>setConfirmation(null)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:16,padding:0,flexShrink:0}}>×</button>
          </div>
        </div>
        {/* Sheet wrote but the app database did not — the failure that used
            to be invisible, so nobody ever reported it. */}
        {confirmation.sheetOk&&confirmation.pgOk===false&&(
          <div style={{marginTop:6,padding:"10px 14px",borderRadius:10,
            background:"rgba(246,191,38,0.1)",border:"1px solid rgba(246,191,38,0.35)"}}>
            <div style={{fontSize:12,fontWeight:700,color:"#F6BF26"}}>⚠️ Saved to the sheet, but not to the app</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.65)",marginTop:3,fontWeight:500}}>
              The money is recorded. This ticket may not show on the calendar. Please tell Rich.
            </div>
            {confirmation.pgError&&<div style={{fontSize:10,color:"rgba(255,255,255,0.4)",marginTop:3}}>{confirmation.pgError}</div>}
          </div>
        )}
      </div>
    );
  };

  // Other appointments today that this person could belong to. Lets a split
  // bill attach the daughter's ticket to the daughter's own calendar entry,
  // so her event gets its own badge instead of looking unfinished.
  const linkOptions=(evts||[]).filter(e=>e.eventId).map(e=>{
    const raw=e.n||"";const dash=raw.indexOf(" - ");
    return{id:e.eventId,label:`${e.t} — ${dash>-1?raw.substring(0,dash).trim():raw.trim()}`};
  });

  const closedStyle=closedAs?styleFor(closedAs):null;

  // ── Collapsed view for a closed ticket ──────────────────────
  if(closedAs){
    return(
      <div style={{background:closedStyle.card,borderRadius:14,padding:desk?"16px 20px":"14px",
        border:`1px solid ${closedStyle.cardBorder}`,borderLeft:`6px solid ${closedStyle.color}`,marginBottom:16}}>
        <ConfirmBanner/>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,minWidth:0}}>
            <span style={{fontSize:22}}>{closedStyle.icon}</span>
            <div style={{minWidth:0}}>
              <div style={{fontSize:15,fontWeight:700,color:"#fff",overflow:"hidden",
                textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{cn}</div>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:600}}>
                {closedStyle.label} · {items.length} item{items.length===1?"":"s"}
                {postSheetRow?` · Row ${postSheetRow}`:""}
                {fTip>0?` · Tip $${fTip.toFixed(2)}`:""}
              </div>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{fontSize:20,fontWeight:800,color:closedStyle.color}}>
              ${(closedAs==="cash"?sub:tot).toFixed(2)}
            </div>
            <button onClick={()=>{setClosedAs(null);setConfirmation(null);}}
              style={{padding:"8px 14px",borderRadius:9,background:"rgba(255,255,255,0.08)",
                border:"1px solid rgba(255,255,255,0.2)",color:"#fff",fontSize:12,
                fontWeight:700,cursor:"pointer"}}>
              ✏️ Edit
            </button>
          </div>
        </div>
      </div>
    );
  }

  return(
    <div style={{background:"rgba(255,255,255,0.03)",borderRadius:14,padding:desk?"18px 20px":"14px 14px",border:"1px solid rgba(255,255,255,0.1)",marginBottom:16}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{width:28,height:28,borderRadius:"50%",background:"#F4511E",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:800,color:"#fff",flexShrink:0}}>{personNum}</div>
          <span style={{fontSize:13,fontWeight:700,color:"rgba(255,255,255,0.7)",textTransform:"uppercase",letterSpacing:.5}}>Person {personNum}</span>
          {postSheetRow&&<div style={{fontSize:10,color:"#F6BF26",background:"rgba(246,191,38,0.1)",border:"1px solid rgba(246,191,38,0.25)",borderRadius:5,padding:"2px 8px",fontWeight:600}}>Row {postSheetRow}</div>}
        </div>
        {onRemove&&<button onClick={onRemove} style={{background:"rgba(231,76,60,0.1)",border:"1px solid rgba(231,76,60,0.2)",borderRadius:7,color:"#E74C3C",fontSize:11,fontWeight:600,cursor:"pointer",padding:"4px 10px"}}>Remove</button>}
      </div>

      <ConfirmBanner/>

      <div style={{display:desk?"grid":"flex",gridTemplateColumns:desk?"1fr 320px":undefined,flexDirection:desk?undefined:"column",gap:desk?20:0}}>
        <div>
          <input value={cn} onChange={e=>setCn(e.target.value)} placeholder="Client name"
            style={{width:"100%",background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:11,padding:"12px 14px",color:"#fff",fontSize:14,fontWeight:600,outline:"none",marginBottom:10,boxSizing:"border-box"}}/>

          {!co.isWalkin&&personNum>1&&linkOptions.length>0&&(
            <div style={{marginBottom:10}}>
              <label style={{fontSize:10,color:"rgba(255,255,255,0.55)",fontWeight:700,letterSpacing:.5,textTransform:"uppercase",display:"block",marginBottom:5}}>
                Their own appointment (optional)
              </label>
              <select value={eventId||""} onChange={e=>setEventId(e.target.value||null)}
                style={{width:"100%",padding:"11px 13px",borderRadius:10,background:"rgba(255,255,255,0.06)",
                  border:"1px solid rgba(255,255,255,0.14)",color:eventId?"#fff":"rgba(255,255,255,0.45)",
                  fontSize:13,fontWeight:600,outline:"none",boxSizing:"border-box"}}>
                <option value="" style={{background:"#1a1a2e"}}>— Not booked separately —</option>
                {linkOptions.map(o=>(
                  <option key={o.id} value={o.id} style={{background:"#1a1a2e",color:"#fff"}}>{o.label}</option>
                ))}
              </select>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.4)",marginTop:4,fontWeight:500}}>
                Links this ticket to their calendar entry so it gets its own badge.
              </div>
            </div>
          )}

          {co.isWalkin&&(
            <input value={phone} onChange={e=>setPhone(e.target.value)} placeholder="Phone number (optional)"
              style={{width:"100%",background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:11,padding:"12px 14px",color:"#fff",fontSize:14,outline:"none",marginBottom:10,boxSizing:"border-box"}}/>
          )}
          {items.length>0&&(
            <div style={{marginBottom:10}}>
              {items.map((it,i)=>(
                <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 12px",marginBottom:3,background:it.ty==="sc"?"rgba(246,191,38,0.08)":"rgba(255,255,255,0.05)",borderRadius:8,borderLeft:`4px solid ${it.ty==="sc"?"#F6BF26":(TC[it.tech]||{bg:"#555"}).bg}`}}>
                  <div style={{display:"flex",alignItems:"center",gap:7}}>
                    <span style={{fontSize:13,color:it.ty==="sc"?"#F6BF26":"#fff",fontWeight:600}}>{it.ty==="sc"?"SC → Store":it.name}</span>
                    {it.ty!=="sc"&&<span style={{fontSize:10,color:"rgba(255,255,255,0.5)"}}>{it.tech}</span>}
                    {it.ty!=="sc"&&parseFloat(it.sc)>0&&(
                      <span style={{fontSize:9,color:"#F6BF26",background:"rgba(246,191,38,0.12)",
                        border:"1px solid rgba(246,191,38,0.25)",borderRadius:4,padding:"1px 5px",fontWeight:700}}>
                        SC ${parseFloat(it.sc).toFixed(0)}
                      </span>
                    )}
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:13,fontWeight:700,color:it.ty==="sc"?"#F6BF26":"#F4511E"}}>${it.price}</span>
                    <button onClick={()=>rm(i)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"#fff",cursor:"pointer",fontSize:13,padding:"2px 7px",borderRadius:5,fontWeight:700}}>×</button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <button onClick={()=>setShowPicker(personNum)}
            style={{width:"100%",padding:"12px",borderRadius:11,background:"rgba(244,81,30,0.1)",border:"2px solid rgba(244,81,30,0.3)",color:"#F4511E",fontSize:13,fontWeight:700,cursor:"pointer"}}>
            + Add Services & Add-ons
          </button>
          {co.isWalkin&&!bookedWalkin&&(
            <div style={{marginTop:8}}>
              <button onClick={handleBookWalkin} disabled={booking}
                style={{width:"100%",padding:"13px",borderRadius:11,
                  background:booking?"rgba(255,255,255,0.05)":"rgba(3,155,229,0.12)",
                  border:`1px solid ${booking?"rgba(255,255,255,0.1)":"rgba(3,155,229,0.3)"}`,
                  color:booking?"rgba(255,255,255,0.4)":"#039BE5",fontSize:14,fontWeight:700,
                  cursor:booking?"default":"pointer"}}>
                {booking?"📅 Booking…":"📅 Add to Calendar"}
              </button>
              {bookError&&<div style={{marginTop:6,padding:"8px 12px",borderRadius:8,
                background:"rgba(231,76,60,0.1)",border:"1px solid rgba(231,76,60,0.25)",
                color:"#E74C3C",fontSize:12,fontWeight:600}}>⚠️ {bookError}</div>}
            </div>
          )}
          {co.isWalkin&&bookedWalkin&&(
            <div style={{marginTop:8,padding:"11px 16px",borderRadius:11,background:"rgba(3,155,229,0.1)",
              border:"1px solid rgba(3,155,229,0.25)",color:"#039BE5",fontSize:13,
              fontWeight:600,textAlign:"center"}}>
              ✓ Added to calendar — refreshes in ~15s
            </div>
          )}
        </div>

        <div style={desk?{position:"sticky",top:20,alignSelf:"start"}:{}}>
          {items.length>0&&(
            <>
              <div style={{background:"rgba(255,255,255,0.05)",borderRadius:12,padding:14,marginBottom:12,border:"1px solid rgba(255,255,255,0.1)",marginTop:desk?0:12}}>
                {Object.entries(tp).map(([t,a])=>(
                  <div key={t} style={{display:"flex",justifyContent:"space-between",marginBottom:3,fontSize:13}}>
                    <span style={{color:(TC[t]||{bg:"#aaa"}).bg,fontWeight:700}}>{t}</span>
                    <span style={{color:"#fff",fontWeight:600}}>${a.toFixed(2)}</span>
                  </div>
                ))}
                <div style={{borderTop:"1px solid rgba(255,255,255,0.1)",margin:"8px 0",paddingTop:8}}>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"rgba(255,255,255,0.6)",marginBottom:5}}><span>SC → Store</span><span>${sc.toFixed(2)}</span></div>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:17,fontWeight:700,marginBottom:4}}><span style={{color:"rgba(255,255,255,0.8)"}}>Before Tax</span><span style={{color:"#fff"}}>${sub.toFixed(2)}</span></div>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"rgba(255,255,255,0.6)",marginBottom:6}}><span>HST 13%</span><span>+${tax.toFixed(2)}</span></div>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:22,fontWeight:800,borderTop:"1px solid rgba(255,255,255,0.12)",paddingTop:8}}><span style={{color:"#fff"}}>Total</span><span style={{color:"#F4511E"}}>${tot.toFixed(2)}</span></div>
                </div>
              </div>
              <div style={{marginBottom:12}}>
                <p style={{fontSize:11,color:"rgba(255,255,255,0.7)",margin:"0 0 7px",textTransform:"uppercase",letterSpacing:.5,fontWeight:700}}>Tip</p>
                <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                  {["0","5","8","10","15","20"].map(t=>(
                    <button key={t} onClick={()=>{setTip(t);setCTip("");}} style={{padding:"7px 12px",borderRadius:8,background:tip===t&&!cTip?"rgba(244,81,30,0.15)":"rgba(255,255,255,0.06)",border:`1px solid ${tip===t&&!cTip?"rgba(244,81,30,0.4)":"rgba(255,255,255,0.12)"}`,color:tip===t&&!cTip?"#F4511E":"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>${t}</button>
                  ))}
                  <input value={cTip} onChange={e=>{setCTip(e.target.value);setTip("");}} placeholder="$" style={{width:50,padding:"7px 8px",borderRadius:8,background:"rgba(255,255,255,0.06)",border:`1px solid ${cTip?"rgba(244,81,30,0.4)":"rgba(255,255,255,0.12)"}`,color:"#fff",fontSize:12,outline:"none",textAlign:"center",fontWeight:600}}/>
                </div>
                {fTip>0&&Object.keys(tp).length>1&&(
                  <div style={{fontSize:10,color:"rgba(255,255,255,0.45)",marginTop:5,fontWeight:500}}>
                    Split between {Object.keys(tp).join(" & ")} by their share of the work.
                  </div>
                )}
              </div>
              <div style={{display:"flex",gap:7,marginBottom:9}}>
                <button onClick={handlePost} disabled={submitting||items.length===0} style={{flex:1,padding:"13px 6px",borderRadius:10,background:"rgba(200,200,200,0.1)",border:"1px solid rgba(200,200,200,0.25)",color:"#fff",fontSize:12,fontWeight:700,cursor:submitting?"default":"pointer",opacity:submitting?0.5:1}}>{submitting?"Posting…":"📋 POST"}</button>
                {postSheetRow&&<button onClick={handleUpdate} disabled={updating||items.length===0} style={{flex:1,padding:"13px 6px",borderRadius:10,background:"rgba(3,155,229,0.12)",border:"1px solid rgba(3,155,229,0.3)",color:"#039BE5",fontSize:12,fontWeight:700,cursor:updating?"default":"pointer",opacity:updating?0.5:1}}>{updating?"Updating…":"🔄 UPDATE"}</button>}
                {postSheetRow&&<button onClick={handleDeleteDraft} disabled={deleting} style={{flex:1,padding:"13px 6px",borderRadius:10,background:"rgba(231,76,60,0.08)",border:"1px solid rgba(231,76,60,0.25)",color:"#E74C3C",fontSize:12,fontWeight:700,cursor:deleting?"default":"pointer",opacity:deleting?0.5:1}}>{deleting?"Deleting…":"🗑 DELETE"}</button>}
              </div>
              <div style={{display:"flex",gap:9,marginBottom:9}}>
                <button onClick={()=>handleClose("Cash")} disabled={submitting} style={{flex:1,padding:"15px",borderRadius:12,background:"linear-gradient(135deg,#1E8449,#27AE60)",border:"none",color:"#fff",fontSize:15,fontWeight:800,cursor:submitting?"default":"pointer",opacity:submitting?0.5:1,boxShadow:"0 4px 16px rgba(39,174,96,0.3)"}}>
                  💵 CASH<br/><span style={{fontSize:11,fontWeight:500,opacity:.85}}>${sub.toFixed(2)}</span>
                </button>
                <button onClick={()=>handleClose("Card")} disabled={submitting} style={{flex:1,padding:"15px",borderRadius:12,background:"linear-gradient(135deg,#922B21,#C0392B)",border:"none",color:"#fff",fontSize:15,fontWeight:800,cursor:submitting?"default":"pointer",opacity:submitting?0.5:1,boxShadow:"0 4px 16px rgba(192,57,43,0.3)"}}>
                  💳 CARD<br/><span style={{fontSize:11,fontWeight:500,opacity:.85}}>${tot.toFixed(2)} w/ tax</span>
                </button>
              </div>
              <button onClick={()=>handleClose("GiftCard")} disabled={submitting}
                style={{width:"100%",padding:"14px",borderRadius:12,
                  background:"linear-gradient(135deg,#0277BD,#039BE5)",border:"none",color:"#fff",
                  fontSize:15,fontWeight:800,cursor:submitting?"default":"pointer",
                  opacity:submitting?0.5:1,boxShadow:"0 4px 16px rgba(3,155,229,0.3)"}}>
                🎁 GIFT CARD<br/><span style={{fontSize:11,fontWeight:500,opacity:.85}}>${tot.toFixed(2)} w/ tax</span>
              </button>
            </>
          )}
        </div>
      </div>

      {showPicker===personNum&&(
        <Modal title={`Add Services — Person ${personNum}`} onClose={()=>setShowPicker(false)} desk={desk}
          footer={<button onClick={applyPicker} style={{width:"100%",padding:"14px",borderRadius:11,background:selectedCount>0?"#F4511E":"rgba(255,255,255,0.07)",border:"none",color:selectedCount>0?"#fff":"rgba(255,255,255,0.4)",fontSize:15,fontWeight:700,cursor:selectedCount>0?"pointer":"default"}}>{selectedCount>0?`Add ${selectedCount} selection${selectedCount>1?"s":""}  →`:"Select services above"}</button>}>
          <div style={{display:"flex",gap:6,paddingBottom:12,overflowX:"auto",flexShrink:0}}>
            {Object.entries(CATS).map(([id,lb])=>{const cnt=id==="addon"?Object.keys(addonSelections).length:Object.keys(selected).filter(k=>SVC[k]?.cat===id).length;return(<button key={id} onClick={()=>setCat(id)} style={{padding:"7px 14px",borderRadius:18,whiteSpace:"nowrap",background:cat===id?"#F4511E":"rgba(255,255,255,0.07)",border:`1px solid ${cat===id?"#F4511E":"rgba(255,255,255,0.12)"}`,color:"#fff",fontSize:12,fontWeight:cat===id?700:500,cursor:"pointer"}}>{lb}{cnt>0?` (${cnt})`:""}</button>);})}
          </div>
          {cat==="wax"&&(
            <div style={{marginBottom:10,padding:"8px 12px",borderRadius:8,background:"rgba(246,191,38,0.08)",
              border:"1px solid rgba(246,191,38,0.2)",fontSize:11,color:"#F6BF26",fontWeight:600}}>
              $3 store cut applies once a tech's wax reaches $30 on this ticket.
            </div>
          )}
          {cat!=="addon"&&cat!=="combo"&&(<div style={{display:"flex",flexDirection:"column",gap:5}}>{Object.entries(SVC).filter(([_,s])=>s.cat===cat).map(([nm,sv])=>{const sel=selected[nm];const checked=!!sel;return(<div key={nm} style={{borderRadius:10,overflow:"hidden",background:checked?"rgba(244,81,30,0.09)":"rgba(255,255,255,0.04)",border:`1px solid ${checked?"rgba(244,81,30,0.3)":"rgba(255,255,255,0.09)"}`}}><button onClick={()=>toggleSelect(nm)} style={{width:"100%",textAlign:"left",padding:"12px 14px",background:"transparent",border:"none",color:"#fff",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}><div style={{display:"flex",alignItems:"center",gap:10}}><div style={{width:20,height:20,borderRadius:5,border:`2px solid ${checked?"#F4511E":"rgba(255,255,255,0.3)"}`,background:checked?"#F4511E":"transparent",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:"#fff",flexShrink:0,fontWeight:700}}>{checked?"✓":""}</div><span style={{fontSize:13,fontWeight:600,color:"#fff"}}>{nm}</span></div><span style={{fontSize:14,fontWeight:700,color:"#F4511E"}}>${sv.p}</span></button>{checked&&<WhoRow label="Who's doing it?" value={sel.tech} onChange={t=>setSvcTech(nm,t)}/>}</div>);})}</div>)}
          {cat==="combo"&&(<div style={{display:"flex",flexDirection:"column",gap:5}}>{Object.entries(SVC).filter(([_,s])=>s.cat==="combo").map(([nm,sv])=>{const sel=selected[nm];const checked=!!sel;return(<div key={nm} style={{borderRadius:11,overflow:"hidden",background:checked?"rgba(244,81,30,0.09)":"rgba(255,255,255,0.04)",border:`1px solid ${checked?"rgba(244,81,30,0.3)":"rgba(255,255,255,0.09)"}`}}><button onClick={()=>toggleCombo(nm)} style={{width:"100%",textAlign:"left",padding:"13px 16px",background:"transparent",border:"none",color:"#fff",cursor:"pointer",display:"flex",alignItems:"center",gap:12}}><div style={{width:20,height:20,borderRadius:5,border:`2px solid ${checked?"#F4511E":"rgba(255,255,255,0.3)"}`,background:checked?"#F4511E":"transparent",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:"#fff",flexShrink:0,fontWeight:700}}>{checked?"✓":""}</div><div style={{flex:1,minWidth:0}}><div style={{fontSize:14,fontWeight:700,color:"#fff",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{nm}</div>{sv.handPart&&<div style={{fontSize:11,color:"rgba(255,255,255,0.6)",marginTop:2}}>💅 {sv.handPart} · 🦶 {sv.feetPart}</div>}</div><span style={{fontSize:15,fontWeight:800,color:"#F4511E",flexShrink:0}}>${sv.p}</span></button>{checked&&<><WhoRow label={`💅 ${sv.handPart||"Hands"} — who?`} value={sel.handTech} onChange={t=>setComboTech(nm,"handTech",t)}/><WhoRow label={`🦶 ${sv.feetPart||"Pedi"} — who?`} value={sel.feetTech} onChange={t=>setComboTech(nm,"feetTech",t)}/></>}</div>);})}
          <div style={{marginTop:12,borderTop:"1px solid rgba(255,255,255,0.08)",paddingTop:12}}><p style={{fontSize:11,color:"rgba(255,255,255,0.6)",margin:"0 0 8px",textTransform:"uppercase",letterSpacing:.5,fontWeight:700}}>Quick Add — Removals</p>{["Shellac Removal w/Svc","Shellac Toe Removal w/Svc"].map(nm=>{const sv=SVC[nm];if(!sv)return null;const sel=selected[nm];const checked=!!sel;return(<div key={nm} style={{borderRadius:9,overflow:"hidden",marginBottom:5,background:checked?"rgba(244,81,30,0.09)":"rgba(255,255,255,0.04)",border:`1px solid ${checked?"rgba(244,81,30,0.3)":"rgba(255,255,255,0.09)"}`}}><button onClick={()=>toggleSelect(nm)} style={{width:"100%",textAlign:"left",padding:"12px 14px",background:"transparent",border:"none",color:"#fff",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}><div style={{display:"flex",alignItems:"center",gap:10}}><div style={{width:20,height:20,borderRadius:5,border:`2px solid ${checked?"#F4511E":"rgba(255,255,255,0.3)"}`,background:checked?"#F4511E":"transparent",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:"#fff",flexShrink:0,fontWeight:700}}>{checked?"✓":""}</div><span style={{fontSize:13,fontWeight:600,color:"#fff"}}>{nm}</span></div><span style={{fontSize:14,fontWeight:700,color:"#F4511E"}}>${sv.p}</span></button>{checked&&<WhoRow label="Who?" value={sel.tech} onChange={t=>setSvcTech(nm,t)}/>}</div>);})}</div></div>)}
          {cat==="addon"&&<div>{ADDONS.map(a=>(<div key={a.n} style={{marginBottom:14}}><p style={{fontSize:13,fontWeight:700,margin:"0 0 7px",color:"#fff"}}>{a.n}</p><div style={{display:"flex",gap:5,flexWrap:"wrap"}}>{a.prs.map(p=>{const k=`${a.n}_${p}`;const on=!!addonSelections[k];return(<div key={k} style={{borderRadius:9,overflow:"hidden",border:`1px solid ${on?"rgba(244,81,30,0.35)":"rgba(255,255,255,0.12)"}`,background:on?"rgba(244,81,30,0.1)":"rgba(255,255,255,0.05)"}}><button onClick={()=>toggleAddon(k,a.n,p)} style={{padding:"9px 16px",background:"transparent",border:"none",color:on?"#F4511E":"#fff",fontSize:13,cursor:"pointer",fontWeight:on?700:600}}>${p}</button>{on&&<WhoRow label="Who?" value={addonSelections[k]?.tech} onChange={t=>setAddonTech(k,t)}/>}</div>);})}</div></div>))}<div style={{marginTop:18,padding:16,borderRadius:11,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)"}}><p style={{fontSize:12,fontWeight:700,margin:"0 0 10px",color:"rgba(255,255,255,0.8)",textTransform:"uppercase",letterSpacing:.5}}>Custom Entry</p><div style={{display:"flex",gap:8,marginBottom:10}}><input value={customName} onChange={e=>setCustomName(e.target.value)} placeholder="Service name (optional)" style={{flex:2,padding:"10px 12px",borderRadius:9,background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.14)",color:"#fff",fontSize:13,outline:"none",fontWeight:500}}/><input value={customPrice} onChange={e=>setCustomPrice(e.target.value)} placeholder="$" style={{flex:1,padding:"10px 12px",borderRadius:9,background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.14)",color:"#fff",fontSize:13,outline:"none",textAlign:"center",fontWeight:700}}/></div>{customPrice&&<WhoRow label="Who's doing it?" value={customTech} onChange={setCustomTech}/>}</div></div>}
        </Modal>
      )}
    </div>
  );
}

function CashoutView({co,close,roster,desk,fetchDrafts,fetchLogs,evts,onSync}){
  const allDrafts=co.allDrafts||(co.postDraft?[co.postDraft]:[]);

  // Each person carries its own calendar_event_id. Person 1 inherits the
  // event that was tapped; a person added now starts unlinked (null) so the
  // backend dedupes them by sheet row instead of colliding on the shared
  // event id — which is what used to make Person 2 overwrite Person 1.
  const[persons,setPersons]=useState(()=>{
    if(allDrafts.length>1){
      return allDrafts.map((d,i)=>({
        id:i+1,
        eventId:d.calendar_event_id||(i===0?(co.eventId||null):null)
      }));
    }
    return [{id:1,eventId:co.eventId||null}];
  });
  const[showPicker,setShowPicker]=useState(false);
  const nextId=React.useRef(allDrafts.length>1?allDrafts.length+1:2);

  const addPerson=()=>{
    setPersons(p=>[...p,{id:nextId.current++,eventId:null}]);
  };

  const removePerson=(id)=>{
    setPersons(p=>p.filter(x=>x.id!==id));
  };

  const setPersonEventId=(id,evId)=>{
    setPersons(p=>p.map(x=>x.id===id?{...x,eventId:evId}:x));
  };

  return(
    <div style={{padding:desk?"22px 32px":"14px 16px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <button onClick={close} data-back-button
          style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.15)",
            borderRadius:9,color:"#fff",padding:"9px 18px",fontSize:14,fontWeight:600,cursor:"pointer"}}>
          ← Back
        </button>
        <span style={{fontSize:12,color:"rgba(255,255,255,0.6)",fontWeight:500}}>
          {co.isWalkin?"🚶 Walk-in":"📅 Calendar"}
        </span>
      </div>

      {persons.map((p,idx)=>(
        <PersonTicket
          key={p.id}
          personNum={idx+1}
          baseName={co.cn||""}
          /* Suffix comes from the live index, so removing person 2 of 3 and
             adding a new one can no longer produce two "Dad +2". A restored
             split ignores this and uses its own draft's name. */
          nameSuffix={idx>0?("+"+idx):null}
          co={{...co,postDraft:allDrafts[idx]||null}}
          roster={roster}
          desk={desk}
          fetchDrafts={fetchDrafts}
          fetchLogs={fetchLogs}
          onRemove={persons.length>1?()=>removePerson(p.id):null}
          showPicker={showPicker}
          setShowPicker={setShowPicker}
          evts={evts}
          eventId={p.eventId}
          setEventId={(evId)=>setPersonEventId(p.id,evId)}
          onSync={onSync}
        />
      ))}

      {!co.isWalkin&&<button onClick={addPerson}
        style={{width:"100%",padding:"13px",borderRadius:11,
          background:"rgba(255,255,255,0.04)",border:"2px dashed rgba(255,255,255,0.15)",
          color:"rgba(255,255,255,0.6)",fontSize:14,fontWeight:700,cursor:"pointer",
          display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
        <span style={{fontSize:20}}>👤</span> + Add Person (Split Bill)
      </button>}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// LOG VIEW
// ══════════════════════════════════════════════════════════════
function LogView({logs,setLogs,desk}){
  const[expanded,setExpanded]=useState(null);
  const[scanning,setScanning]=useState(false);
  const[voiding,setVoiding]=useState(null);
  const[scanSummary,setScanSummary]=useState(null);

  const handleScan=async()=>{
    setScanning(true);setScanSummary(null);
    try{
      const res=await fetch('/api/logs/scan');
      const data=await res.json();
      if(data.success){setLogs(data.rows||[]);setScanSummary(data);}
      else{alert("Scan failed: "+(data.error||"unknown"));}
    }catch(e){console.error("scan:",e);alert("Could not reach server");}
    setScanning(false);
  };

  const handleVoid=async(log)=>{
    if(!window.confirm(`Zero out row ${log.sheet_row} for ${log.client_name}? This highlights it purple on the sheet.`)) return;
    setVoiding(log.sheet_row);
    try{
      const res=await fetch('/api/logs/void',{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({sheet_row:log.sheet_row,sheet_tab:log.sheet_tab})});
      const data=await res.json();
      if(data.success){
        setLogs(p=>p.map(l=>l.sheet_row===log.sheet_row
          ?{...l,voided:true,tech_pay:{},tech_tips:{},sc:0,sub:0}:l));
        if(scanSummary) setScanSummary(null);
      }else{alert("Void failed: "+(data.error||"unknown"));}
    }catch(e){alert("Could not reach server");}
    setVoiding(null);
  };

  const payStyle=(p)=>p==="Cash"?STATUS_STYLE.cash:p==="GiftCard"?STATUS_STYLE.giftcard:STATUS_STYLE.card;

  const cashTotal  =scanSummary?scanSummary.cash_total      :logs.filter(l=>!l.voided&&l.payment==="Cash").reduce((a,l)=>a+l.sub,0);
  const cardTotal  =scanSummary?scanSummary.card_total      :logs.filter(l=>!l.voided&&l.payment==="Card").reduce((a,l)=>a+l.sub,0);
  const giftTotal  =scanSummary?scanSummary.gift_card_total :logs.filter(l=>!l.voided&&l.payment==="GiftCard").reduce((a,l)=>a+l.sub,0);
  const prodTotal  =scanSummary?scanSummary.products_total  :0;
  const grandTotal =scanSummary?scanSummary.grand_total     :cashTotal+cardTotal+giftTotal;
  const techTotals =scanSummary?scanSummary.tech_totals     :(()=>{const t={};logs.filter(l=>!l.voided).forEach(l=>{Object.entries(l.tech_pay||{}).forEach(([k,v])=>{t[k]=(t[k]||0)+v;});});return t;})();
  const techTips   =scanSummary?scanSummary.tech_tip_totals :(()=>{const t={};logs.filter(l=>!l.voided).forEach(l=>{Object.entries(l.tech_tips||{}).forEach(([k,v])=>{t[k]=(t[k]||0)+v;});});return t;})();

  return(
    <div style={{padding:desk?"22px 32px":"14px 16px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div>
          <h2 style={{margin:0,fontSize:desk?22:18,fontWeight:700,color:"#fff"}}>📊 Daily Log</h2>
          <p style={{margin:"3px 0 0",fontSize:12,color:"rgba(255,255,255,0.6)",fontWeight:500}}>
            {scanSummary?`${scanSummary.ticket_count} tickets scanned`:logs.length>0?`${logs.length} entries loaded`:"Tap Complete Scan to load today's data"}
          </p>
        </div>
        <button onClick={handleScan} disabled={scanning}
          style={{padding:"9px 18px",borderRadius:9,
            background:scanning?"rgba(255,255,255,0.05)":"rgba(142,36,170,0.15)",
            border:`1px solid ${scanning?"rgba(255,255,255,0.08)":"rgba(142,36,170,0.35)"}`,
            color:scanning?"rgba(255,255,255,0.4)":"#CE93D8",fontSize:12,fontWeight:700,
            cursor:scanning?"default":"pointer"}}>
          {scanning?"🔄 Scanning…":"🔍 Complete Scan"}
        </button>
      </div>

      {!scanSummary&&logs.length>0&&(
        <div style={{padding:"9px 14px",borderRadius:9,background:"rgba(255,255,255,0.04)",
          border:"1px solid rgba(255,255,255,0.1)",marginBottom:14,
          fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:500}}>
          Quick view — product sales aren't included. Run Complete Scan for the full day.
        </div>
      )}

      {scanSummary&&(
        <div style={{padding:"11px 16px",borderRadius:11,background:"rgba(142,36,170,0.1)",
          border:"1px solid rgba(142,36,170,0.25)",marginBottom:16}}>
          <div style={{fontSize:12,color:"#CE93D8",fontWeight:700,marginBottom:3}}>
            ✅ Scan complete — {scanSummary.ticket_count} tickets · rows 4–60
          </div>
          <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:500}}>
            Green = Cash · Red = Card · Blue = Gift Card · Purple = Void
          </div>
        </div>
      )}

      <div style={{display:"grid",
        gridTemplateColumns:giftTotal>0||prodTotal>0?"1fr 1fr 1fr 1fr":"1fr 1fr 1fr",
        gap:9,marginBottom:16}}>
        {[
          {label:"Grand Total",val:`$${grandTotal.toFixed(2)}`,color:"#F4511E",big:true},
          {label:"💵 Cash",val:`$${cashTotal.toFixed(2)}`,color:"#2ECC71"},
          {label:"💳 Card",val:`$${cardTotal.toFixed(2)}`,color:"#E74C3C"},
          ...(giftTotal>0?[{label:"🎁 Gift Card",val:`$${giftTotal.toFixed(2)}`,color:"#039BE5"}]:[]),
          ...(prodTotal>0?[{label:"📦 Products",val:`$${prodTotal.toFixed(2)}`,color:"#F6BF26"}]:[]),
        ].map(s=>(
          <div key={s.label} style={{background:"rgba(255,255,255,0.05)",borderRadius:11,
            padding:"12px 14px",border:"1px solid rgba(255,255,255,0.1)"}}>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.65)",marginBottom:4,fontWeight:600}}>{s.label}</div>
            <div style={{fontSize:s.big?20:16,fontWeight:800,color:s.color}}>{s.val}</div>
          </div>
        ))}
      </div>

      {Object.keys(techTotals).length>0&&(
        <div style={{background:"rgba(255,255,255,0.03)",borderRadius:12,padding:"12px 16px",
          marginBottom:16,border:"1px solid rgba(255,255,255,0.09)"}}>
          <div style={{fontSize:11,color:"rgba(255,255,255,0.7)",marginBottom:10,
            textTransform:"uppercase",letterSpacing:.5,fontWeight:700}}>Staff Pay Today</div>
          <div style={{display:"grid",gridTemplateColumns:desk?"1fr 1fr 1fr":"1fr 1fr",gap:7}}>
            {Object.entries(techTotals).map(([tech,amt])=>(
              <div key={tech} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
                padding:"8px 12px",borderRadius:8,background:"rgba(255,255,255,0.04)",
                border:"1px solid rgba(255,255,255,0.07)"}}>
                <div style={{display:"flex",alignItems:"center",gap:7}}>
                  <Dot name={tech} sz={20}/>
                  <span style={{fontSize:13,color:"#fff",fontWeight:600}}>{tech}</span>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:13,fontWeight:800,color:(TC[tech]||{bg:"#aaa"}).bg}}>
                    ${amt.toFixed(2)}
                  </div>
                  {techTips[tech]&&(
                    <div style={{fontSize:10,color:"rgba(255,255,255,0.55)",fontWeight:500}}>
                      +${techTips[tech].toFixed(2)} tip
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {logs.length===0&&!scanSummary&&(
        <div style={{textAlign:"center",padding:"48px 0",color:"rgba(255,255,255,0.4)"}}>
          <div style={{fontSize:36,marginBottom:10,opacity:.4}}>📊</div>
          <div style={{fontSize:14,fontWeight:500}}>Tap Complete Scan to read today's full sheet</div>
          <div style={{fontSize:12,color:"rgba(255,255,255,0.3)",marginTop:6,fontWeight:400}}>
            Reads all rows 4–60 and classifies by cell color
          </div>
        </div>
      )}

      <div style={{display:"flex",flexDirection:"column",gap:7}}>
        {[...logs].sort((a,b)=>a.sheet_row-b.sheet_row).map((l)=>{
          const isOpen=expanded===l.sheet_row;
          const isVoided=l.voided;
          const ps=payStyle(l.payment);
          return(
            <div key={l.sheet_row} style={{borderRadius:11,overflow:"hidden",
              background:isVoided?"rgba(142,36,170,0.07)":"rgba(255,255,255,0.04)",
              border:`1px solid ${isVoided?"rgba(142,36,170,0.25)":ps.cardBorder}`}}>
              <button onClick={()=>setExpanded(isOpen?null:l.sheet_row)}
                style={{width:"100%",textAlign:"left",padding:"13px 16px",background:"transparent",
                  border:"none",color:"#fff",cursor:"pointer",display:"flex",
                  justifyContent:"space-between",alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <span style={{fontSize:18}}>{isVoided?"🟣":ps.icon}</span>
                  <div>
                    <div style={{fontSize:14,fontWeight:700,color:isVoided?"rgba(255,255,255,0.35)":"#fff",
                      textDecoration:isVoided?"line-through":"none"}}>
                      {l.client_name||"Walk-in"}
                    </div>
                    <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:500}}>
                      Row {l.sheet_row}
                      {l.tip>0?` · Tip $${l.tip.toFixed(2)}`:""}
                      {isVoided?" · VOIDED":""}
                    </div>
                  </div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:16,fontWeight:800,color:isVoided?"rgba(142,36,170,0.6)":"#F4511E"}}>
                    ${l.sub.toFixed(2)}
                  </div>
                  <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:600}}>{l.payment}</div>
                </div>
              </button>
              {isOpen&&(
                <div style={{padding:"0 16px 16px",borderTop:"1px solid rgba(255,255,255,0.08)"}}>
                  {l.svc_c&&(
                    <div style={{fontSize:12,color:"rgba(255,255,255,0.75)",marginTop:10,
                      whiteSpace:"pre-line",fontWeight:500,lineHeight:1.6}}>
                      {l.svc_c}{l.svc_d?"\n"+l.svc_d:""}
                    </div>
                  )}
                  {Object.keys(l.tech_pay||{}).length>0&&(
                    <div style={{marginTop:10,display:"flex",flexDirection:"column",gap:3}}>
                      {Object.entries(l.tech_pay).map(([tech,amt])=>(
                        <div key={tech} style={{display:"flex",justifyContent:"space-between",fontSize:12}}>
                          <span style={{color:(TC[tech]||{bg:"#aaa"}).bg,fontWeight:700}}>{tech}</span>
                          <span style={{color:"rgba(255,255,255,0.75)",fontWeight:600}}>
                            ${amt.toFixed(2)}
                            {l.tech_tips?.[tech]?` + $${l.tech_tips[tech].toFixed(2)} tip`:""}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                  {!isVoided&&(
                    <button onClick={()=>handleVoid(l)} disabled={voiding===l.sheet_row}
                      style={{marginTop:12,padding:"8px 16px",borderRadius:8,
                        background:"rgba(142,36,170,0.1)",border:"1px solid rgba(142,36,170,0.25)",
                        color:"#CE93D8",fontSize:12,fontWeight:700,
                        cursor:voiding===l.sheet_row?"default":"pointer",
                        opacity:voiding===l.sheet_row?0.5:1}}>
                      {voiding===l.sheet_row?"Voiding…":"🟣 Void Row"}
                    </button>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// MY SALES VIEW (tech-only)
// Co-worker PAY is no longer shown — only who shared the ticket.
// ══════════════════════════════════════════════════════════════
function MySalesView({techName,desk}){
  const[data,setData]=useState(null);
  const[loading,setLoading]=useState(true);
  const[error,setError]=useState(null);
  const[expanded,setExpanded]=useState(null);

  const fetchSales=async()=>{
    setLoading(true);setError(null);
    try{
      const res=await fetch(`/api/my-sales?tech=${encodeURIComponent(techName)}`);
      const result=await res.json();
      if(result.success){setData(result);}
      else{setError(result.error||"Could not load sales");}
    }catch(e){setError("Connection error");}
    setLoading(false);
  };

  useEffect(()=>{fetchSales();},[techName]); // eslint-disable-line

  const techColor=(TC[techName]||{bg:"#F4511E"}).bg;
  const payStyle=(p)=>p==="Cash"?STATUS_STYLE.cash:p==="GiftCard"?STATUS_STYLE.giftcard:STATUS_STYLE.card;

  return(
    <div style={{padding:desk?"22px 32px":"14px 16px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <Dot name={techName} sz={36}/>
          <div>
            <h2 style={{margin:0,fontSize:desk?22:18,fontWeight:700,color:"#fff"}}>
              {techName}'s Sales
            </h2>
            <p style={{margin:"3px 0 0",fontSize:12,color:"rgba(255,255,255,0.6)",fontWeight:500}}>
              {loading?"Loading…":data?`${data.ticket_count} tickets today`:"No data"}
            </p>
          </div>
        </div>
        <button onClick={fetchSales} disabled={loading}
          style={{padding:"9px 18px",borderRadius:9,
            background:loading?"rgba(255,255,255,0.05)":"rgba(244,81,30,0.15)",
            border:`1px solid ${loading?"rgba(255,255,255,0.08)":"rgba(244,81,30,0.35)"}`,
            color:loading?"rgba(255,255,255,0.4)":"#F4511E",fontSize:12,fontWeight:700,
            cursor:loading?"default":"pointer"}}>
          {loading?"🔄 Loading…":"🔄 Update"}
        </button>
      </div>

      {error&&(
        <div style={{padding:"11px 16px",borderRadius:11,background:"rgba(231,76,60,0.1)",
          border:"1px solid rgba(231,76,60,0.25)",marginBottom:16,color:"#E74C3C",
          fontSize:13,fontWeight:600}}>
          ⚠️ {error}
        </div>
      )}

      {data&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:9,marginBottom:16}}>
          {[
            {label:"Total Pay",val:`$${data.pay_total.toFixed(2)}`,color:techColor,big:true},
            {label:"💰 Tips",val:`$${data.tips_total.toFixed(2)}`,color:"#F6BF26"},
            {label:"Grand Total",val:`$${data.grand_total.toFixed(2)}`,color:"#F4511E"},
          ].map(s=>(
            <div key={s.label} style={{background:"rgba(255,255,255,0.05)",borderRadius:11,
              padding:"12px 14px",border:"1px solid rgba(255,255,255,0.1)"}}>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.65)",marginBottom:4,fontWeight:600}}>
                {s.label}
              </div>
              <div style={{fontSize:s.big?20:16,fontWeight:800,color:s.color}}>{s.val}</div>
            </div>
          ))}
        </div>
      )}

      {data&&data.rows.length===0&&!loading&&(
        <div style={{textAlign:"center",padding:"48px 0",color:"rgba(255,255,255,0.4)"}}>
          <div style={{fontSize:36,marginBottom:10,opacity:.4}}>💅</div>
          <div style={{fontSize:14,fontWeight:500}}>No sales yet today</div>
          <div style={{fontSize:12,color:"rgba(255,255,255,0.3)",marginTop:6,fontWeight:400}}>
            Tickets will appear here as they're closed out
          </div>
        </div>
      )}

      <div style={{display:"flex",flexDirection:"column",gap:7}}>
        {data&&data.rows.map((l)=>{
          const isOpen=expanded===l.sheet_row;
          const ps=payStyle(l.payment);
          const others=l.with_techs||[];
          return(
            <div key={l.sheet_row} style={{borderRadius:11,overflow:"hidden",
              background:"rgba(255,255,255,0.04)",
              border:`1px solid ${ps.cardBorder}`}}>
              <button onClick={()=>setExpanded(isOpen?null:l.sheet_row)}
                style={{width:"100%",textAlign:"left",padding:"13px 16px",background:"transparent",
                  border:"none",color:"#fff",cursor:"pointer",display:"flex",
                  justifyContent:"space-between",alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",gap:12,flex:1,minWidth:0}}>
                  <span style={{fontSize:18}}>{ps.icon}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,fontWeight:700,color:"#fff",
                      overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                      {l.client_name||"Walk-in"}
                    </div>
                    <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:500,
                      display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                      <span>Row {l.sheet_row}</span>
                      {l.my_tip>0&&<span>· Tip ${l.my_tip.toFixed(2)}</span>}
                      {others.length>0&&(
                        <span style={{display:"inline-flex",alignItems:"center",gap:4}}>
                          · with {others.map((wt,i)=>(
                            <span key={wt.name} style={{display:"inline-flex",alignItems:"center",gap:3}}>
                              <Dot name={wt.name} sz={14}/>
                              <span style={{color:(TC[wt.name]||{bg:"#aaa"}).bg,fontWeight:700}}>{wt.name}</span>
                              {i<others.length-1?",":""}
                            </span>
                          ))}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div style={{textAlign:"right",flexShrink:0}}>
                  <div style={{fontSize:16,fontWeight:800,color:techColor}}>
                    ${l.my_pay.toFixed(2)}
                  </div>
                  <div style={{fontSize:11,color:"rgba(255,255,255,0.6)",fontWeight:600}}>
                    {l.payment}
                  </div>
                </div>
              </button>
              {isOpen&&(
                <div style={{padding:"0 16px 16px",borderTop:"1px solid rgba(255,255,255,0.08)"}}>
                  {l.svc_c&&(
                    <div style={{fontSize:13,color:"#fff",marginTop:12,
                      whiteSpace:"pre-line",fontWeight:600,lineHeight:1.6}}>
                      {l.svc_c}{l.svc_d?"\n"+l.svc_d:""}
                    </div>
                  )}
                  {/* Full ticket breakdown, same shape as the cashout view.
                      Co-workers on this ticket are shown with their pay —
                      rows she did not work never reach her at all. */}
                  <div style={{marginTop:12,padding:"14px",borderRadius:12,
                    background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)"}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:4,fontSize:14}}>
                      <span style={{color:techColor,fontWeight:700}}>Your pay</span>
                      <span style={{color:"#fff",fontWeight:700}}>${l.my_pay.toFixed(2)}</span>
                    </div>
                    {others.map(wt=>(
                      <div key={wt.name} style={{display:"flex",justifyContent:"space-between",
                        alignItems:"center",marginBottom:4,fontSize:13}}>
                        <span style={{display:"inline-flex",alignItems:"center",gap:5}}>
                          <Dot name={wt.name} sz={16}/>
                          <span style={{color:(TC[wt.name]||{bg:"#aaa"}).bg,fontWeight:700}}>{wt.name}</span>
                        </span>
                        <span style={{color:"#fff",fontWeight:600}}>
                          {typeof wt.pay==="number"?`$${wt.pay.toFixed(2)}`:""}
                        </span>
                      </div>
                    ))}
                    <div style={{borderTop:"1px solid rgba(255,255,255,0.1)",margin:"8px 0",paddingTop:8}}>
                      {l.sc>0&&(
                        <div style={{display:"flex",justifyContent:"space-between",fontSize:12,
                          color:"rgba(255,255,255,0.6)",marginBottom:5}}>
                          <span>SC → Store</span>
                          <span>${l.sc.toFixed(2)}</span>
                        </div>
                      )}
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:15,fontWeight:700,marginBottom:4}}>
                        <span style={{color:"rgba(255,255,255,0.85)"}}>Before Tax</span>
                        <span style={{color:"#fff"}}>${l.before_tax.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:12,
                        color:"rgba(255,255,255,0.6)",marginBottom:6}}>
                        <span>HST 13%</span>
                        <span>+${l.tax.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:18,fontWeight:800,
                        borderTop:"1px solid rgba(255,255,255,0.12)",paddingTop:8}}>
                        <span style={{color:"#fff"}}>Total</span>
                        <span style={{color:"#F4511E"}}>${l.total.toFixed(2)}</span>
                      </div>
                    </div>
                    {l.my_tip>0&&(
                      <div style={{marginTop:10,paddingTop:10,
                        borderTop:"1px dashed rgba(255,255,255,0.15)",
                        display:"flex",justifyContent:"space-between",fontSize:13}}>
                        <span style={{color:"rgba(255,255,255,0.7)",fontWeight:600}}>💰 Your tip</span>
                        <span style={{color:"#F6BF26",fontWeight:700}}>${l.my_tip.toFixed(2)}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}